/* ========================================
   BK-MEDIA CUSTOM JAVASCRIPT
   ======================================== */

/* ========================================
   SMOOTH SCROLL FUNCTION
   ======================================== */

   let isScrolling = false;

   function smoothScrollTo(targetElement, options) {
     if (!targetElement) return;
     if (isScrolling) return;
     
     isScrolling = true;
     
     const offset = options?.offset || 20;
     const callback = options?.callback || null;
     
     function calculateScrollPosition() {
       const rect = targetElement.getBoundingClientRect();
       const absoluteElementTop = rect.top + window.scrollY;
       return absoluteElementTop - offset;
     }
     
     function waitForLayoutStable(callback, maxAttempts = 10) {
       let attempts = 0;
       let lastPosition = calculateScrollPosition();
       
       function checkStable() {
         const currentPosition = calculateScrollPosition();
         
         if (Math.abs(currentPosition - lastPosition) < 1 || attempts >= maxAttempts) {
           callback(currentPosition);
           return;
         }
         
         lastPosition = currentPosition;
         attempts++;
         requestAnimationFrame(checkStable);
       }
       
       requestAnimationFrame(checkStable);
     }
     
     waitForLayoutStable((stablePosition) => {
       const targetPosition = stablePosition;
       const startPosition = window.scrollY;
       const distance = targetPosition - startPosition;
       const duration = options?.duration || 1200;
       let start = null;
       
       function animateScroll(currentTime) {
         if (start === null) start = currentTime;
         
         const timeElapsed = currentTime - start;
         const progress = Math.min(timeElapsed / duration, 1);
         
         const easeInOutCubic = progress < 0.5
           ? 4 * progress * progress * progress
           : 1 - Math.pow(-2 * progress + 2, 3) / 2;
         
         window.scrollTo(0, startPosition + distance * easeInOutCubic);
         
         if (timeElapsed < duration) {
           requestAnimationFrame(animateScroll);
         } else {
           waitForLayoutStable((finalPosition) => {
             window.scrollTo(0, finalPosition);
             setTimeout(() => {
               isScrolling = false;
               if (callback && typeof callback === 'function') {
                 callback();
               }
             }, 50);
           }, 5);
         }
       }
       
       requestAnimationFrame(animateScroll);
     });
   }
   
   /* ========================================
      FAQ SCROLL OFFSET HELPER
      ======================================== */
   
   function getFAQScrollOffset() {
     const header = document.querySelector('.header');
     if (!header) return 20;
     const headerHeight = header.offsetHeight;
     // Add extra padding for better visibility
     return Math.max(headerHeight + 20, 20);
   }
   
   /* ========================================
      MULTI-COLUMN POPUP INITIALIZATION
      ======================================== */
   
   function initMultiColumnPopups() {
     const popupOverlay = document.getElementById('bk-media-multicolumn-popup-overlay');
     if (!popupOverlay) return;
   
     const closeButton = popupOverlay.querySelector('.bk-media-multicolumn-popup-close');
     const overlayBackground = popupOverlay.querySelector('.bk-media-multicolumn-popup-overlay');
     const popupTriggers = document.querySelectorAll('.bk-media-multicolumn-popup-trigger');
     const clickableItems = document.querySelectorAll('.bk-media-multicolumn-item-clickable');
     
     const getPrevButton = () => {
       const activePanel = panels().find(panel => window.getComputedStyle(panel).display !== 'none');
       return activePanel ? activePanel.querySelector('.bk-media-multicolumn-popup-prev') : null;
     };
     
     const getNextButton = () => {
       const activePanel = panels().find(panel => window.getComputedStyle(panel).display !== 'none');
       return activePanel ? activePanel.querySelector('.bk-media-multicolumn-popup-next') : null;
     };
   
     let currentIndex = 0;
     const panels = () => Array.from(popupOverlay.querySelectorAll('[data-popup-panel]'));
     const panelCount = () => panels().length;
     const dots = () => Array.from(popupOverlay.querySelectorAll('[data-popup-dot]'));
   
     function updateButtonStates() {
       const count = panelCount();
       const prevButton = getPrevButton();
       const nextButton = getNextButton();
       
       panels().forEach(panel => {
         const panelPrev = panel.querySelector('.bk-media-multicolumn-popup-prev');
         const panelNext = panel.querySelector('.bk-media-multicolumn-popup-next');
         
         if (panelPrev) {
           if (currentIndex === 0) {
             panelPrev.disabled = true;
             panelPrev.setAttribute('aria-disabled', 'true');
           } else {
             panelPrev.disabled = false;
             panelPrev.setAttribute('aria-disabled', 'false');
           }
         }
         if (panelNext) {
           if (currentIndex === count - 1) {
             panelNext.disabled = true;
             panelNext.setAttribute('aria-disabled', 'true');
           } else {
             panelNext.disabled = false;
             panelNext.setAttribute('aria-disabled', 'false');
           }
         }
       });
     }
   
     function preloadAdjacentImages(index) {
       const allPanels = panels();
       const prevIndex = index - 1;
       const nextIndex = index + 1;
       
       if (prevIndex >= 0) {
         const prevPanel = allPanels[prevIndex];
         if (prevPanel) {
           const prevImg = prevPanel.querySelector('img');
           if (prevImg && !prevImg.complete) {
             const link = document.createElement('link');
             link.rel = 'preload';
             link.as = 'image';
             link.href = prevImg.src;
             link.hrefset = prevImg.srcset || '';
             document.head.appendChild(link);
           }
         }
       }
       
       if (nextIndex < allPanels.length) {
         const nextPanel = allPanels[nextIndex];
         if (nextPanel) {
           const nextImg = nextPanel.querySelector('img');
           if (nextImg && !nextImg.complete) {
             const link = document.createElement('link');
             link.rel = 'preload';
             link.as = 'image';
             link.href = nextImg.src;
             link.hrefset = nextImg.srcset || '';
             document.head.appendChild(link);
           }
         }
       }
     }
     
     function showPanel(index) {
       const allPanels = panels();
       
       allPanels.forEach(panel => {
         const textInner = panel.querySelector('.bk-media-multicolumn-popup-text-inner');
         if (textInner && panel.style.display !== 'none') {
           const currentMaxHeight = textInner.style.maxHeight;
           if (currentMaxHeight) {
             panel.setAttribute('data-text-height', currentMaxHeight);
           }
         }
         panel.style.display = 'none';
       });
       
       const boundedIndex = Math.max(0, Math.min(index, allPanels.length - 1));
       const target = allPanels[boundedIndex];
       if (target) {
         target.style.display = 'flex';
         currentIndex = boundedIndex;
         
         const img = target.querySelector('img');
         if (img && img.loading === 'lazy') {
           img.loading = 'eager';
         }
         
         const textInner = target.querySelector('.bk-media-multicolumn-popup-text-inner');
         if (textInner) {
           const savedHeight = target.getAttribute('data-text-height');
           if (savedHeight) {
             const heightValue = parseFloat(savedHeight);
             
             if (heightValue <= 0) {
               textInner.style.maxHeight = '0';
               textInner.style.overflow = 'hidden';
               textInner.style.paddingTop = '0';
               textInner.style.paddingBottom = '0';
               textInner.style.opacity = '0';
               textInner.style.height = '0';
               textInner.style.marginTop = '0';
               textInner.style.marginBottom = '0';
             } else {
               textInner.style.maxHeight = savedHeight;
               textInner.style.opacity = '';
               textInner.style.height = '';
               textInner.style.marginTop = '';
               textInner.style.marginBottom = '';
               
               textInner.style.maxHeight = 'none';
               textInner.style.height = 'auto';
               const fullHeight = textInner.offsetHeight;
               textInner.style.maxHeight = Math.min(heightValue, fullHeight) + 'px';
               textInner.style.height = '';
             }
             
             const textContainer = textInner.closest('.bk-media-multicolumn-popup-dots.bk-media-multicolumn-popup-text');
             if (textContainer) {
               textContainer.scrollTop = 0;
             }
           } else {
             textInner.style.maxHeight = '';
             textInner.style.opacity = '';
             textInner.style.height = '';
             textInner.style.paddingTop = '';
             textInner.style.paddingBottom = '';
             textInner.style.marginTop = '';
             textInner.style.marginBottom = '';
           }
         }
         
         preloadAdjacentImages(boundedIndex);
       }
   
       dots().forEach(dot => {
         const idx = parseInt(dot.getAttribute('data-popup-dot'), 10);
         dot.setAttribute('aria-current', idx === currentIndex ? 'true' : 'false');
       });
   
       updateButtonStates();
     }
   
     function preloadAllImages() {
       const allPanels = panels();
       allPanels.forEach((panel, index) => {
         const img = panel.querySelector('img');
         if (img && index > 0) {
           const link = document.createElement('link');
           link.rel = 'preload';
           link.as = 'image';
           link.href = img.src;
           link.hrefset = img.srcset || '';
           document.head.appendChild(link);
         }
       });
     }
     
     function openPopup(panelIndex) {
       const parsed = typeof panelIndex === 'string' ? parseInt(panelIndex, 10) : panelIndex;
       const initialIndex = isNaN(parsed) ? 0 : parsed;
       showPanel(initialIndex);
       popupOverlay.hidden = false;
       ensureBodyScrollLock();
       
       setTimeout(() => {
         preloadAllImages();
       }, 100);
     }
   
     function closePopup() {
       popupOverlay.hidden = true;
       document.body.style.overflow = '';
     }
     
     function ensureBodyScrollLock() {
       if (!popupOverlay.hidden) {
         document.body.style.overflow = 'hidden';
       }
     }
   
     function goNext() {
       if (currentIndex < panelCount() - 1) {
         showPanel(currentIndex + 1);
       }
     }
   
     function goPrev() {
       if (currentIndex > 0) {
         showPanel(currentIndex - 1);
       }
     }
   
     popupTriggers.forEach(trigger => {
       trigger.addEventListener('click', function(e) {
         e.preventDefault();
         const panelIndex = this.getAttribute('data-popup-trigger');
         openPopup(panelIndex);
       });
     });
   
     clickableItems.forEach(item => {
       item.addEventListener('click', function(e) {
         // Don't trigger if clicking on links, buttons, or other interactive elements
         const interactive = e.target.closest('a, button, [data-ignore-popup]');
         if (interactive) return;
         
         const panelIndex = this.getAttribute('data-popup-trigger');
         openPopup(panelIndex);
       });
     });
   
     if (closeButton) {
       closeButton.addEventListener('click', closePopup);
     }
   
    if (overlayBackground) {
      overlayBackground.addEventListener('click', closePopup);
    }
  
    window.openMultiColumnPopup = function(panelIndex) {
      const parsed = typeof panelIndex === 'string' ? parseInt(panelIndex, 10) : panelIndex;
      const initialIndex = isNaN(parsed) ? 0 : parsed;
      showPanel(initialIndex);
      popupOverlay.hidden = false;
      ensureBodyScrollLock();
      
      setTimeout(() => {
        preloadAllImages();
      }, 100);
    };
  
    popupOverlay.addEventListener('click', function(e) {
      if (e.target.closest('.bk-media-multicolumn-popup-prev')) {
        e.preventDefault();
        e.stopPropagation();
        goPrev();
      } else if (e.target.closest('.bk-media-multicolumn-popup-next')) {
        e.preventDefault();
        e.stopPropagation();
        goNext();
      }
    });
  
    dots().forEach(dot => {
       dot.addEventListener('click', function() {
         const idx = parseInt(this.getAttribute('data-popup-dot'), 10);
         if (!isNaN(idx)) {
           showPanel(idx);
         }
       });
     });

    let isResizingPopup = false;
    
    function collapseTextSection(panel) {
      const textInner = panel.querySelector('.bk-media-multicolumn-popup-text-inner');
      if (!textInner) return;
      
      const textContainer = textInner.closest('.bk-media-multicolumn-popup-dots.bk-media-multicolumn-popup-text');
      const popupContent = popupOverlay.querySelector('.bk-media-multicolumn-popup-content');
      const heading = textInner.querySelector('.bk-media-multicolumn-popup-heading');
      
      requestAnimationFrame(() => {
        textInner.style.transition = 'max-height 0.6s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1), padding-top 0.6s cubic-bezier(0.4, 0, 0.2, 1), padding-bottom 0.6s cubic-bezier(0.4, 0, 0.2, 1), margin-top 0.6s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        
        if (heading) {
          heading.style.transition = 'opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        }
        
        if (textContainer) {
          textContainer.style.transition = 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        }
        
        if (popupContent) {
          popupContent.style.scrollBehavior = 'smooth';
        }
        
        textInner.style.maxHeight = '0';
        textInner.style.overflow = 'hidden';
        textInner.style.paddingTop = '0';
        textInner.style.paddingBottom = '0';
        textInner.style.opacity = '0';
        textInner.style.height = '0';
        textInner.style.marginTop = '0';
        textInner.style.marginBottom = '0';
        
        if (heading) {
          heading.style.opacity = '0';
          heading.style.marginBottom = '0';
        }
        
        panel.setAttribute('data-text-height', '0');
        
        setTimeout(() => {
          textInner.style.transition = '';
          if (heading) {
            heading.style.transition = '';
            heading.style.opacity = '';
            heading.style.marginBottom = '';
          }
          if (textContainer) {
            textContainer.style.transition = '';
          }
          if (popupContent) {
            popupContent.style.scrollBehavior = '';
          }
        }, 600);
      });
    }
    
    function expandTextSection(panel) {
      const textInner = panel.querySelector('.bk-media-multicolumn-popup-text-inner');
      if (!textInner) return;
      
      const textContainer = textInner.closest('.bk-media-multicolumn-popup-dots.bk-media-multicolumn-popup-text');
      const popupContent = popupOverlay.querySelector('.bk-media-multicolumn-popup-content');
      const heading = textInner.querySelector('.bk-media-multicolumn-popup-heading');
      
      requestAnimationFrame(() => {
        textInner.style.transition = 'max-height 0.6s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1), padding-top 0.6s cubic-bezier(0.4, 0, 0.2, 1), padding-bottom 0.6s cubic-bezier(0.4, 0, 0.2, 1), margin-top 0.6s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        
        if (heading) {
          heading.style.transition = 'opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1), margin-bottom 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
          heading.style.opacity = '1';
          heading.style.marginBottom = '';
        }
        
        if (textContainer) {
          textContainer.style.transition = 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
        }
        
        if (popupContent) {
          popupContent.style.scrollBehavior = 'smooth';
        }
        
        textInner.style.maxHeight = 'none';
        textInner.style.height = 'auto';
        textInner.style.opacity = '1';
        textInner.style.paddingTop = '';
        textInner.style.paddingBottom = '';
        textInner.style.marginTop = '';
        textInner.style.marginBottom = '';
        textInner.style.overflow = '';
        
        requestAnimationFrame(() => {
          const fullHeight = textInner.offsetHeight;
          textInner.style.maxHeight = fullHeight + 'px';
          textInner.style.height = '';
          
          panel.setAttribute('data-text-height', fullHeight + 'px');
          
          if (textContainer) {
            textContainer.scrollTop = 0;
          }
          
          setTimeout(() => {
            textInner.style.transition = '';
            if (heading) {
              heading.style.transition = '';
            }
            if (textContainer) {
              textContainer.style.transition = '';
            }
            if (popupContent) {
              popupContent.style.scrollBehavior = '';
            }
          }, 600);
        });
      });
    }
    
    function initPopupResize() {
      if (!popupOverlay) return;
      
      const textContainers = popupOverlay.querySelectorAll('.bk-media-multicolumn-popup-dots.bk-media-multicolumn-popup-text');
      if (textContainers.length === 0) return;
      
      textContainers.forEach(textContainer => {
        const handle = textContainer.querySelector('.bk-media-multicolumn-popup-resize-handle');
        if (!handle) return;
        let dragging = false;
        let initialY = 0;
        let initialX = 0;
        let startMaxHeight = 0;
        let fullHeight = 0;
        let textInner = null;
        let hasMoved = false;

        function onPointerDown(event) {
          const isInteractive = event.target.closest('a, button, .bk-media-multicolumn-popup-dot');
          if (isInteractive && !event.target.closest('.bk-media-multicolumn-popup-resize-handle')) {
            return;
          }
          
          const isInTextInner = event.target.closest('.bk-media-multicolumn-popup-text-inner');
          const isInHeading = event.target.closest('.bk-media-multicolumn-popup-heading, .bk-media-multicolumn-popup-title-section');
          const isOnResizeHandle = event.target.closest('.bk-media-multicolumn-popup-resize-handle');
          const isInDotsInner = event.target.closest('.bk-media-multicolumn-popup-dots-inner');
          
          if (!isInTextInner && !isInHeading && !isOnResizeHandle && !isInDotsInner) {
            return;
          }
          
          event.preventDefault();
          event.stopPropagation();
          dragging = true;
          isResizingPopup = true;
          hasMoved = false;
          initialY = event.clientY;
          initialX = event.clientX;
          
          textInner = textContainer.querySelector('.bk-media-multicolumn-popup-text-inner');
          const popupContent = popupOverlay.querySelector('.bk-media-multicolumn-popup-content');
          
          if (textInner) {
              const computedStyle = window.getComputedStyle(textInner);
              const currentMaxHeight = computedStyle.maxHeight;
              const currentHeight = parseFloat(currentMaxHeight) || 0;
              const isCollapsed = currentHeight <= 0;
              
              let calculatedFullHeight = currentHeight;
              if (!isCollapsed) {
                textInner.style.maxHeight = 'none';
                textInner.style.height = 'auto';
                calculatedFullHeight = textInner.offsetHeight;
                textInner.style.maxHeight = currentMaxHeight;
                textInner.style.height = '';
              } else {
                const savedHeight = textInner.closest('.bk-media-multicolumn-popup-panel')?.getAttribute('data-text-height');
                if (savedHeight && parseFloat(savedHeight) > 0) {
                  calculatedFullHeight = parseFloat(savedHeight);
                } else {
                  const originalOpacity = textInner.style.opacity;
                  const originalPaddingTop = textInner.style.paddingTop;
                  const originalPaddingBottom = textInner.style.paddingBottom;
                  
                  textInner.style.maxHeight = 'none';
                  textInner.style.height = 'auto';
                  textInner.style.opacity = '1';
                  textInner.style.paddingTop = '';
                  textInner.style.paddingBottom = '';
                  calculatedFullHeight = textInner.offsetHeight;
                  
                  textInner.style.maxHeight = '0';
                  textInner.style.height = '0';
                  textInner.style.opacity = originalOpacity || '0';
                  textInner.style.paddingTop = originalPaddingTop || '0';
                  textInner.style.paddingBottom = originalPaddingBottom || '0';
                }
              }
              
              fullHeight = calculatedFullHeight;
              
              if (currentMaxHeight === 'none' || currentMaxHeight === '1000px' || parseFloat(currentMaxHeight) >= fullHeight) {
                startMaxHeight = fullHeight;
              } else {
                startMaxHeight = currentHeight || 0;
              }
              
              document.body.style.cursor = 'ns-resize';
              document.body.style.userSelect = 'none';
              ensureBodyScrollLock();
              
              if (popupContent) {
                popupContent.style.overflow = 'hidden';
              }
              
              const panel = textInner.closest('.bk-media-multicolumn-popup-panel');
              if (panel) {
                panel.style.overflow = 'hidden';
              }
              
              textInner.style.transition = 'none';
              textInner.style.minHeight = '0';
              textContainer.setPointerCapture(event.pointerId);
            }
          }

        function onPointerMove(event) {
          if (!dragging || !textInner) return;
          
          const deltaY = Math.abs(initialY - event.clientY);
          const deltaX = Math.abs(initialX - event.clientX);
          const moveThreshold = 2;
          
          if (deltaX > deltaY * 1.5 && deltaX > 15) {
            dragging = false;
            isResizingPopup = false;
            hasMoved = false;
            textContainer.releasePointerCapture(event.pointerId);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            if (textInner) {
              textInner.style.transition = '';
            }
            const swipeDistance = event.clientX - initialX;
            if (Math.abs(swipeDistance) >= 50) {
              if (swipeDistance > 0) {
                const prevBtn = getPrevButton();
                if (prevBtn && !prevBtn.disabled) {
                  goPrev();
                }
              } else {
                const nextBtn = getNextButton();
                if (nextBtn && !nextBtn.disabled) {
                  goNext();
                }
              }
            }
            return;
          }
          
          event.preventDefault();
          event.stopPropagation();
          
          const deltaYValue = initialY - event.clientY;
          
          if (Math.abs(deltaYValue) > moveThreshold) {
            hasMoved = true;
          }
          
          const newMaxHeight = Math.max(0, Math.min(startMaxHeight + deltaYValue, fullHeight));
          
          textInner.style.maxHeight = newMaxHeight + 'px';
          textInner.style.minHeight = '0';
          
          const panel = textInner.closest('.bk-media-multicolumn-popup-panel');
          if (panel) {
            panel.setAttribute('data-text-height', newMaxHeight + 'px');
          }
          
          if (newMaxHeight <= 0) {
            textInner.style.overflow = 'hidden';
            textInner.style.paddingTop = '0';
            textInner.style.paddingBottom = '0';
            textInner.style.opacity = '0';
            textInner.style.marginTop = '0';
            textInner.style.marginBottom = '0';
            textInner.style.height = '0';
          } else {
            textInner.style.overflow = newMaxHeight < fullHeight ? 'hidden' : 'visible';
            textInner.style.opacity = '1';
            textInner.style.marginTop = '';
            textInner.style.marginBottom = '';
            textInner.style.height = '';
            if (newMaxHeight > 0 && textInner.style.paddingTop === '0') {
              textInner.style.paddingTop = '';
              textInner.style.paddingBottom = '';
            }
          }
          
          const textContainer = textInner.closest('.bk-media-multicolumn-popup-dots.bk-media-multicolumn-popup-text');
          if (textContainer) {
            textContainer.scrollTop = 0;
          }
        }

        function onPointerUp(event) {
          if (dragging) {
            event.preventDefault();
            event.stopPropagation();
            
            if (textContainer.hasPointerCapture && textContainer.hasPointerCapture(event.pointerId)) {
              textContainer.releasePointerCapture(event.pointerId);
            }
          }
          
          const popupContent = popupOverlay.querySelector('.bk-media-multicolumn-popup-content');
          
          if (textInner) {
            const currentMaxHeight = textInner.style.maxHeight;
            const panel = textInner.closest('.bk-media-multicolumn-popup-panel');
            
            if (panel && currentMaxHeight) {
              panel.setAttribute('data-text-height', currentMaxHeight);
            }
            
            textInner.style.transition = '';
            
            if (parseFloat(currentMaxHeight) > 0) {
              textInner.style.paddingTop = '';
              textInner.style.paddingBottom = '';
              textInner.style.opacity = '';
              textInner.style.marginTop = '';
              textInner.style.marginBottom = '';
            }
            
            textInner.style.minHeight = '';
          }
          
          if (popupContent) {
            popupContent.style.overflow = '';
            popupContent.scrollTop = 0;
          }
          
          const panel = textInner?.closest('.bk-media-multicolumn-popup-panel');
          if (panel) {
            panel.style.overflow = '';
            panel.scrollTop = 0;
          }
          
          dragging = false;
          isResizingPopup = false;
          resizeEndTime = Date.now();
          fullHeight = 0;
          
          setTimeout(() => {
            if (!isResizingPopup) {
              hasMoved = false;
              textInner = null;
            }
          }, resizeCooldown);
          
          document.body.style.cursor = '';
          document.body.style.userSelect = '';
          
          ensureBodyScrollLock();
        }

        textContainer.addEventListener('pointerdown', onPointerDown, { passive: false });
        textContainer.addEventListener('pointermove', onPointerMove, { passive: false });
        textContainer.addEventListener('pointerup', onPointerUp, { passive: false });
        textContainer.addEventListener('pointercancel', onPointerUp, { passive: false });
      });
    }

    // Drag functionality removed - popup now uses normal scrolling like product gallery popup
    // try {
    //   initPopupResize();
    // } catch (error) {
    //   console.error('Error initializing popup resize:', error);
    // }
    
   
     document.addEventListener('keydown', function(e) {
       if (popupOverlay.hidden) return;
       ensureBodyScrollLock();
       if (e.key === 'Escape') {
         closePopup();
       } else if (e.key === 'ArrowRight') {
         const nextBtn = getNextButton();
         if (nextBtn && !nextBtn.disabled) {
           goNext();
         }
       } else if (e.key === 'ArrowLeft') {
         const prevBtn = getPrevButton();
         if (prevBtn && !prevBtn.disabled) {
           goPrev();
         }
       }
     });
     
     const observer = new MutationObserver(function(mutations) {
       mutations.forEach(function(mutation) {
         if (mutation.type === 'attributes' && mutation.attributeName === 'hidden') {
           ensureBodyScrollLock();
         }
       });
     });
     
     observer.observe(popupOverlay, {
       attributes: true,
       attributeFilter: ['hidden']
     });
   
     let touchStartX = 0;
     let touchEndX = 0;
     let touchStartY = 0;
     let touchEndY = 0;
     let touchStartedOnResizeHandle = false;
     let touchStartedOnTextSection = false;
     let touchHasMoved = false;
     const minSwipeDistance = 50;
     let resizeEndTime = 0;
     const resizeCooldown = 100;
   
     function handleTouchStart(e) {
       if (popupOverlay.hidden) return;
       
       const textSection = e.target.closest('.bk-media-multicolumn-popup-dots.bk-media-multicolumn-popup-text');
       const mediaSection = e.target.closest('.bk-media-multicolumn-popup-media');
       const isInteractive = e.target.closest('a, button, .bk-media-multicolumn-popup-dot');
       
       if (isResizingPopup) {
         return;
       }
       
       touchStartedOnResizeHandle = false;
       touchStartedOnTextSection = !!textSection;
       touchHasMoved = false;
       touchStartX = e.changedTouches[0].screenX;
       touchStartY = e.changedTouches[0].screenY;
     }
 
     function handleTouchMove(e) {
       if (isResizingPopup) {
         return;
       }
       
       if (e.changedTouches.length > 0 && touchStartX !== 0) {
         const deltaX = Math.abs(e.changedTouches[0].screenX - touchStartX);
         const deltaY = Math.abs(e.changedTouches[0].screenY - touchStartY);
         
         const textSection = e.target.closest('.bk-media-multicolumn-popup-dots.bk-media-multicolumn-popup-text');
         if ((textSection || touchStartedOnTextSection) && deltaY > deltaX * 1.5 && deltaY > 15) {
           touchStartedOnResizeHandle = true;
           touchHasMoved = true;
         }
       }
     }
 
     function handleTouchEnd(e) {
       if (popupOverlay.hidden) return;
       
       const now = Date.now();
       if (now - resizeEndTime < resizeCooldown && isResizingPopup) {
         touchStartedOnResizeHandle = false;
         touchStartedOnTextSection = false;
         return;
       }
       
       if (isResizingPopup) {
         touchStartedOnResizeHandle = false;
         touchStartedOnTextSection = false;
         return;
       }
       
       if (!touchStartX) {
         touchStartedOnResizeHandle = false;
         touchStartedOnTextSection = false;
         return;
       }
       
       touchEndX = e.changedTouches[0].screenX;
       touchEndY = e.changedTouches[0].screenY;
       
       const deltaY = Math.abs(touchEndY - touchStartY);
       const deltaX = Math.abs(touchEndX - touchStartX);
       
       const textSection = e.target.closest('.bk-media-multicolumn-popup-dots.bk-media-multicolumn-popup-text');
       const wasOnTextSection = textSection || touchStartedOnTextSection;
       
       if (deltaX < minSwipeDistance) {
         touchStartedOnResizeHandle = false;
         touchStartedOnTextSection = false;
         return;
       }
       
       if (wasOnTextSection && (touchStartedOnResizeHandle || deltaY > deltaX * 1.5 || deltaY > 20)) {
         touchStartedOnResizeHandle = false;
         touchStartedOnTextSection = false;
         return;
       }
       
       if (deltaX >= minSwipeDistance && (deltaX > deltaY * 1.5 || deltaY <= 20)) {
         handleSwipe();
       }
       
       touchStartedOnResizeHandle = false;
       touchStartedOnTextSection = false;
     }
 
     function handleSwipe() {
       if (isResizingPopup || touchStartedOnResizeHandle || touchStartedOnTextSection) {
         return;
       }
       
       const swipeDistance = touchEndX - touchStartX;
       
       if (Math.abs(swipeDistance) < minSwipeDistance) return;
 
       const prevBtn = getPrevButton();
       const nextBtn = getNextButton();
       if (swipeDistance > 0 && prevBtn && !prevBtn.disabled) {
         goPrev();
       } else if (swipeDistance < 0 && nextBtn && !nextBtn.disabled) {
         goNext();
       }
     }
   
     popupOverlay.addEventListener('touchstart', handleTouchStart, { passive: true });
     popupOverlay.addEventListener('touchmove', handleTouchMove, { passive: true });
     popupOverlay.addEventListener('touchend', handleTouchEnd, { passive: true });
   }
   
   /* ========================================
      USP POPUP INITIALIZATION
      ======================================== */
   
   function initUSPPopups() {
     const popupOverlays = document.querySelectorAll('.bk-media-usp-popup[id^="bk-media-usp-popup-overlay"]');
     if (popupOverlays.length === 0) return;
   
     popupOverlays.forEach(popupOverlay => {
       const popupOverlayId = popupOverlay.id;
       const productGalleryId = popupOverlay.getAttribute('data-product-gallery-id');
       const productGallery = productGalleryId ? document.querySelector(`#${productGalleryId}`)?.closest('.product-gallery') : null;
       
       const closeButton = popupOverlay.querySelector('.bk-media-usp-popup-close');
       const overlayBackground = popupOverlay.querySelector('.bk-media-usp-popup-overlay');
       
       const popupTriggers = productGallery 
         ? productGallery.querySelectorAll(`[data-popup-trigger][data-popup-overlay-id="${popupOverlayId}"]`)
         : document.querySelectorAll(`[data-popup-trigger][data-popup-overlay-id="${popupOverlayId}"]`);
       
       const desktopImageTriggers = productGallery
         ? productGallery.querySelectorAll(`[data-popup-trigger-desktop][data-popup-overlay-id="${popupOverlayId}"]`)
         : document.querySelectorAll(`[data-popup-trigger-desktop][data-popup-overlay-id="${popupOverlayId}"]`);
       
       const mobileImageTriggers = productGallery
         ? productGallery.querySelectorAll(`[data-popup-trigger-mobile][data-popup-overlay-id="${popupOverlayId}"]`)
         : document.querySelectorAll(`[data-popup-trigger-mobile][data-popup-overlay-id="${popupOverlayId}"]`);
     
       const getPrevButton = () => {
         const activePanel = panels().find(panel => window.getComputedStyle(panel).display !== 'none');
         return activePanel ? activePanel.querySelector('.bk-media-usp-popup-prev') : null;
       };
     
       const getNextButton = () => {
         const activePanel = panels().find(panel => window.getComputedStyle(panel).display !== 'none');
         return activePanel ? activePanel.querySelector('.bk-media-usp-popup-next') : null;
       };
     
       let currentIndex = 0;
       const panels = () => Array.from(popupOverlay.querySelectorAll('[data-popup-panel]'));
       const panelCount = () => panels().length;
       const dots = () => Array.from(popupOverlay.querySelectorAll('[data-popup-dot]'));
   
       function updateButtonStates() {
       const count = panelCount();
       panels().forEach(panel => {
         const panelPrev = panel.querySelector('.bk-media-usp-popup-prev');
         const panelNext = panel.querySelector('.bk-media-usp-popup-next');
         
         if (panelPrev) {
           if (currentIndex === 0) {
             panelPrev.disabled = true;
             panelPrev.setAttribute('aria-disabled', 'true');
           } else {
             panelPrev.disabled = false;
             panelPrev.setAttribute('aria-disabled', 'false');
           }
         }
         if (panelNext) {
           if (currentIndex === count - 1) {
             panelNext.disabled = true;
             panelNext.setAttribute('aria-disabled', 'true');
           } else {
             panelNext.disabled = false;
             panelNext.setAttribute('aria-disabled', 'false');
           }
         }
       });
     }
   
       window.updateUSPPopupButtonStates = function(index) {
         currentIndex = index;
         updateButtonStates();
       };
     
     
       function setEqualPanelHeights() {
         const allPanels = panels();
         if (allPanels.length === 0) return;
         const popupContent = popupOverlay.querySelector('.bk-media-usp-popup-content');
         if (!popupContent) return;
         
         const isMobile = window.matchMedia('(max-width: 699px)').matches;
         
         if (isMobile) {
           allPanels.forEach(panel => {
             panel.style.height = 'auto';
             panel.style.minHeight = 'auto';
           });
           popupContent.style.height = 'auto';
           return;
         }
     
         allPanels.forEach(panel => {
           panel.style.height = 'auto';
           panel.style.minHeight = 'auto';
         });
         popupContent.style.height = 'auto';
       }
     
         function showPanel(index) {
         const allPanels = panels();
         const popupContent = popupOverlay.querySelector('.bk-media-usp-popup-content');
         const isMobile = window.matchMedia('(max-width: 699px)').matches;
         const panelHeight = isMobile ? null : (popupContent ? popupContent.getAttribute('data-panel-height') : null);
         
         allPanels.forEach(panel => {
           panel.style.display = 'none';
           if (panelHeight) {
             panel.style.height = panelHeight + 'px';
             panel.style.minHeight = panelHeight + 'px';
           } else {
             panel.style.height = 'auto';
             panel.style.minHeight = 'auto';
           }
         });
         
        const boundedIndex = Math.max(0, Math.min(index, allPanels.length - 1));
        const target = allPanels[boundedIndex];
        if (target) {
          target.style.display = 'block';
          if (panelHeight) {
            target.style.height = panelHeight + 'px';
            target.style.minHeight = panelHeight + 'px';
          } else {
            target.style.height = 'auto';
            target.style.minHeight = 'auto';
          }
        }
        currentIndex = boundedIndex;
     
         dots().forEach(dot => {
           const idx = parseInt(dot.getAttribute('data-popup-dot'), 10);
           dot.setAttribute('aria-current', idx === currentIndex ? 'true' : 'false');
         });
     
         updateButtonStates();
       }
     
       function openPopup(panelIndex) {
         const parsed = typeof panelIndex === 'string' ? parseInt(panelIndex, 10) : panelIndex;
         setEqualPanelHeights();
         showPanel(isNaN(parsed) ? 0 : parsed);
         popupOverlay.hidden = false;
         document.body.style.overflow = 'hidden';
       }
     
       function closePopup() {
         popupOverlay.hidden = true;
         document.body.style.overflow = '';
       }
     
       function goNext() {
         if (currentIndex < panelCount() - 1) {
           showPanel(currentIndex + 1);
         }
       }
     
       function goPrev() {
         if (currentIndex > 0) {
           showPanel(currentIndex - 1);
         }
       }
     
       popupTriggers.forEach(trigger => {
         trigger.addEventListener('click', function(e) {
           e.preventDefault();
           const panelIndex = this.getAttribute('data-popup-trigger');
           openPopup(panelIndex);
         });
       });
     
       const isDesktop = () => window.matchMedia('(min-width: 1000px)').matches;
     
       desktopImageTriggers.forEach(trigger => {
         trigger.addEventListener('click', function(e) {
           if (!isDesktop()) return;
           const interactive = e.target.closest('button, a, [data-ignore-popup]');
           if (interactive) return;
           const index = this.getAttribute('data-popup-trigger-desktop');
           if (index != null) {
             openPopup(index);
           }
         });
       });
     
       // Handle mobile image triggers
       const isMobile = () => window.matchMedia('(max-width: 999px)').matches;
       
       mobileImageTriggers.forEach(trigger => {
         trigger.addEventListener('click', function(e) {
           if (!isMobile()) return;
           const interactive = e.target.closest('button, a, [data-ignore-popup]');
           if (interactive) return;
           const index = this.getAttribute('data-popup-trigger-mobile');
           if (index != null) {
             e.preventDefault();
             openPopup(index);
           }
         });
       });
     
       if (closeButton) {
         closeButton.addEventListener('click', closePopup);
       }
     
       if (overlayBackground) {
         overlayBackground.addEventListener('click', closePopup);
       }
     
      popupOverlay.addEventListener('click', function(e) {
        if (e.target.closest('.bk-media-usp-popup-prev')) {
          e.preventDefault();
          e.stopPropagation();
          goPrev();
        } else if (e.target.closest('.bk-media-usp-popup-next')) {
          e.preventDefault();
          e.stopPropagation();
          goNext();
        }
      });
   
       dots().forEach(dot => {
         dot.addEventListener('click', function() {
           if (isMobile()) return;
           const idx = parseInt(this.getAttribute('data-popup-dot'), 10);
           if (!isNaN(idx)) {
             showPanel(idx);
           }
         });
       });
     
       window.addEventListener('resize', function() {
         if (!popupOverlay.hidden) {
           setEqualPanelHeights();
         }
       });
     
       document.addEventListener('keydown', function(e) {
         if (popupOverlay.hidden) return;
         if (e.key === 'Escape') {
           closePopup();
         } else if (e.key === 'ArrowRight') {
           const nextBtn = getNextButton();
           if (nextBtn && !nextBtn.disabled) {
             goNext();
           }
         } else if (e.key === 'ArrowLeft') {
           const prevBtn = getPrevButton();
           if (prevBtn && !prevBtn.disabled) {
             goPrev();
           }
         }
       });
     
       let touchStartX = 0;
       let touchEndX = 0;
       const minSwipeDistance = 50;
     
       function handleTouchStart(e) {
         if (popupOverlay.hidden) return;
         touchStartX = e.changedTouches[0].screenX;
       }
     
       function handleTouchEnd(e) {
         if (popupOverlay.hidden) return;
         touchEndX = e.changedTouches[0].screenX;
         handleSwipe();
       }
     
       function handleSwipe() {
         const swipeDistance = touchEndX - touchStartX;
         
         if (Math.abs(swipeDistance) < minSwipeDistance) return;
     
         if (swipeDistance > 0) {
           const prevBtn = getPrevButton();
           if (prevBtn && !prevBtn.disabled) {
             goPrev();
           }
         } else if (swipeDistance < 0) {
           const nextBtn = getNextButton();
           if (nextBtn && !nextBtn.disabled) {
             goNext();
           }
         }
       }
     
       popupOverlay.addEventListener('touchstart', handleTouchStart, { passive: true });
       popupOverlay.addEventListener('touchend', handleTouchEnd, { passive: true });
     
       window.addEventListener('resize', function() {
         if (!popupOverlay.hidden) {
           setEqualPanelHeights();
         }
       });
     });
   }
   
   /* ========================================
      USP POPUP ZOOM FUNCTIONALITY
      ======================================== */
   
   function initUSPPopupZoom() {
     const zoomButtons = document.querySelectorAll('.bk-media-usp-popup-image [is="product-zoom-button"]');
     if (zoomButtons.length === 0) return;
   
     const productGallery = document.querySelector('product-gallery');
     if (!productGallery || !productGallery.hasAttribute('allow-zoom')) return;
   
     const maxZoomLevel = parseInt(productGallery.getAttribute('allow-zoom')) || 3;
   
     zoomButtons.forEach(button => {
       button.addEventListener('click', function(e) {
         e.preventDefault();
         e.stopPropagation();
         
         const imageContainer = this.closest('.bk-media-usp-popup-image');
         const img = imageContainer.querySelector('img');
         if (!img) return;
   
         const panels = Array.from(document.querySelectorAll('[data-popup-panel]'));
         const images = panels
           .map(panel => {
             const panelImg = panel.querySelector('.bk-media-usp-popup-image img');
             if (!panelImg) return null;
             
             const zoomUrl = panelImg.getAttribute('data-zoom-image') || panelImg.src;
             const thumbnailEl = panelImg;
             
             return {
               src: zoomUrl,
               width: panelImg.naturalWidth || 2000,
               height: panelImg.naturalHeight || 2000,
               thumbnailElement: thumbnailEl
             };
           })
           .filter(img => img !== null);
   
         if (images.length === 0) return;
   
         const currentPanel = imageContainer.closest('[data-popup-panel]');
         const currentIndex = panels.indexOf(currentPanel);
   
         import("vendor").then(({ PhotoSwipeLightbox }) => {
           const photoswipe = new PhotoSwipeLightbox({
             pswpModule: () => import("photoswipe"),
             bgOpacity: 1,
             maxZoomLevel: maxZoomLevel,
             closeTitle: window.themeVariables?.strings?.closeGallery || 'Close',
             zoomTitle: window.themeVariables?.strings?.zoomGallery || 'Zoom',
             errorMsg: window.themeVariables?.strings?.errorGallery || 'Error loading image',
             arrowPrev: false,
             arrowNext: false,
             counter: false,
             zoom: false,
             closeSVG: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56">
               <path d="M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28Z" fill="#fff"/>
               <path d="M55.5 28C55.5 12.812 43.188.5 28 .5S.5 12.812.5 28 12.812 55.5 28 55.5 55.5 43.188 55.5 28Z" stroke="#252627" stroke-opacity=".12"/>
               <path d="m22.344 22.343 11.313 11.314m-11.313 0 11.313-11.313" stroke="#252627" stroke-width="2"/>
             </svg>`
           });
   
           photoswipe.addFilter("thumbEl", (thumbEl, data) => data["thumbnailElement"]);
           photoswipe.init();
           photoswipe.loadAndOpen(currentIndex >= 0 ? currentIndex : 0);
         }).catch(() => {
           console.warn('PhotoSwipe not available');
         });
       });
     });
   }
   
   /* ========================================
      SCROLLABLE IMAGES POPUP INITIALIZATION
      ======================================== */
   
   function initScrollableImagesPopups() {
     const popupOverlays = document.querySelectorAll('.bk-media-scrollable-images-popup');
     
     popupOverlays.forEach(popupOverlay => {
       const closeButton = popupOverlay.querySelector('.bk-media-scrollable-images-popup-close');
       const overlayBackground = popupOverlay.querySelector('.bk-media-scrollable-images-popup-overlay');
       const popupTriggers = document.querySelectorAll('.bk-media-scrollable-images-item-clickable');
       
       let currentIndex = 0;
       const panels = () => Array.from(popupOverlay.querySelectorAll('[data-popup-panel]'));
       
       const getPrevButton = () => {
         const activePanel = panels().find(panel => window.getComputedStyle(panel).display !== 'none');
         return activePanel ? activePanel.querySelector('.bk-media-scrollable-images-popup-prev') : null;
       };
       
       const getNextButton = () => {
         const activePanel = panels().find(panel => window.getComputedStyle(panel).display !== 'none');
         return activePanel ? activePanel.querySelector('.bk-media-scrollable-images-popup-next') : null;
       };
       const panelCount = () => panels().length;
       const dots = () => Array.from(popupOverlay.querySelectorAll('[data-popup-dot]'));
   
       function updateButtonStates() {
         const count = panelCount();
         
         panels().forEach(panel => {
           const panelPrev = panel.querySelector('.bk-media-scrollable-images-popup-prev');
           const panelNext = panel.querySelector('.bk-media-scrollable-images-popup-next');
           
           if (panelPrev) {
             if (currentIndex === 0) {
               panelPrev.disabled = true;
               panelPrev.setAttribute('aria-disabled', 'true');
             } else {
               panelPrev.disabled = false;
               panelPrev.setAttribute('aria-disabled', 'false');
             }
           }
           if (panelNext) {
             if (currentIndex === count - 1) {
               panelNext.disabled = true;
               panelNext.setAttribute('aria-disabled', 'true');
             } else {
               panelNext.disabled = false;
               panelNext.setAttribute('aria-disabled', 'false');
             }
           }
         });
       }
   
       function preloadAdjacentImages(index) {
         const allPanels = panels();
         const prevIndex = index - 1;
         const nextIndex = index + 1;
         
         if (prevIndex >= 0) {
           const prevPanel = allPanels[prevIndex];
           if (prevPanel) {
             const prevImg = prevPanel.querySelector('img');
             if (prevImg && !prevImg.complete) {
               const link = document.createElement('link');
               link.rel = 'preload';
               link.as = 'image';
               link.href = prevImg.src;
               link.hrefset = prevImg.srcset || '';
               document.head.appendChild(link);
             }
           }
         }
         
         if (nextIndex < allPanels.length) {
           const nextPanel = allPanels[nextIndex];
           if (nextPanel) {
             const nextImg = nextPanel.querySelector('img');
             if (nextImg && !nextImg.complete) {
               const link = document.createElement('link');
               link.rel = 'preload';
               link.as = 'image';
               link.href = nextImg.src;
               link.hrefset = nextImg.srcset || '';
               document.head.appendChild(link);
             }
           }
         }
       }
       
       function showPanel(index) {
         const allPanels = panels();
         allPanels.forEach(panel => {
           panel.style.display = 'none';
         });
         const boundedIndex = Math.max(0, Math.min(index, allPanels.length - 1));
         const target = allPanels[boundedIndex];
         if (target) {
           target.style.display = 'block';
           currentIndex = boundedIndex;
           
           const img = target.querySelector('img');
           if (img && img.loading === 'lazy') {
             img.loading = 'eager';
           }
           
           preloadAdjacentImages(boundedIndex);
         }
   
         dots().forEach(dot => {
           const idx = parseInt(dot.getAttribute('data-popup-dot'), 10);
           dot.setAttribute('aria-current', idx === currentIndex ? 'true' : 'false');
         });
   
         updateButtonStates();
       }
   
       function preloadAllImages() {
         const allPanels = panels();
         allPanels.forEach((panel, index) => {
           const img = panel.querySelector('img');
           if (img && index > 0) {
             const link = document.createElement('link');
             link.rel = 'preload';
             link.as = 'image';
             link.href = img.src;
             link.hrefset = img.srcset || '';
             document.head.appendChild(link);
           }
         });
       }
       
       function openPopup(panelIndex) {
         const parsed = typeof panelIndex === 'string' ? parseInt(panelIndex, 10) : panelIndex;
         const initialIndex = isNaN(parsed) ? 0 : parsed;
         showPanel(initialIndex);
         popupOverlay.hidden = false;
         document.body.style.overflow = 'hidden';
         
         setTimeout(() => {
           preloadAllImages();
         }, 100);
       }
   
       function closePopup() {
         popupOverlay.hidden = true;
         document.body.style.overflow = '';
       }
   
       function goNext() {
         if (currentIndex < panelCount() - 1) {
           showPanel(currentIndex + 1);
         }
       }
   
       function goPrev() {
         if (currentIndex > 0) {
           showPanel(currentIndex - 1);
         }
       }
   
       // Only attach listeners to triggers that belong to this popup's section
       const sectionId = popupOverlay.getAttribute('data-section-id');
       if (sectionId) {
         const sectionElement = document.getElementById('shopify-section-' + sectionId);
         if (sectionElement) {
           const sectionTriggers = Array.from(sectionElement.querySelectorAll('.bk-media-scrollable-images-item-clickable'));
   
           sectionTriggers.forEach(trigger => {
             // Use a data attribute to prevent duplicate listeners
             if (!trigger.hasAttribute('data-popup-initialized')) {
               trigger.setAttribute('data-popup-initialized', 'true');
               trigger.addEventListener('click', function(e) {
                 e.preventDefault();
                 const panelIndex = this.getAttribute('data-popup-trigger');
                 openPopup(panelIndex);
               });
             }
           });
   
           // Also handle button clicks within the items
           const sectionButtons = Array.from(sectionElement.querySelectorAll('.bk-media-scrollable-images-popup-trigger'));
           sectionButtons.forEach(button => {
             if (!button.hasAttribute('data-popup-initialized')) {
               button.setAttribute('data-popup-initialized', 'true');
               button.addEventListener('click', function(e) {
                 e.stopPropagation();
                 e.preventDefault();
                 const panelIndex = this.getAttribute('data-popup-trigger');
                 openPopup(panelIndex);
               });
             }
           });
         }
       } else {
         // Fallback: attach to all triggers if section ID not found
         popupTriggers.forEach(trigger => {
           if (!trigger.hasAttribute('data-popup-initialized')) {
             trigger.setAttribute('data-popup-initialized', 'true');
             trigger.addEventListener('click', function(e) {
               e.preventDefault();
               const panelIndex = this.getAttribute('data-popup-trigger');
               openPopup(panelIndex);
             });
           }
         });
   
         // Also handle button clicks in fallback
         const allButtons = document.querySelectorAll('.bk-media-scrollable-images-popup-trigger');
         allButtons.forEach(button => {
           if (!button.hasAttribute('data-popup-initialized')) {
             button.setAttribute('data-popup-initialized', 'true');
             button.addEventListener('click', function(e) {
               e.stopPropagation();
               e.preventDefault();
               const panelIndex = this.getAttribute('data-popup-trigger');
               openPopup(panelIndex);
             });
           }
         });
       }
   
       if (closeButton) {
         closeButton.addEventListener('click', closePopup);
       }
   
       if (overlayBackground) {
         overlayBackground.addEventListener('click', closePopup);
       }
   
       popupOverlay.addEventListener('click', function(e) {
         if (e.target.closest('.bk-media-scrollable-images-popup-prev')) {
           e.preventDefault();
           e.stopPropagation();
           goPrev();
         } else if (e.target.closest('.bk-media-scrollable-images-popup-next')) {
           e.preventDefault();
           e.stopPropagation();
           goNext();
         }
       });
   
       dots().forEach(dot => {
         dot.addEventListener('click', function() {
           const idx = parseInt(this.getAttribute('data-popup-dot'), 10);
           if (!isNaN(idx)) {
             showPanel(idx);
           }
         });
       });
   
       document.addEventListener('keydown', function(e) {
         if (popupOverlay.hidden) return;
         if (e.key === 'Escape') {
           closePopup();
         } else if (e.key === 'ArrowRight') {
           const nextBtn = getNextButton();
           if (nextBtn && !nextBtn.disabled) {
             goNext();
           }
         } else if (e.key === 'ArrowLeft') {
           const prevBtn = getPrevButton();
           if (prevBtn && !prevBtn.disabled) {
             goPrev();
           }
         }
       });
   
       let touchStartX = 0;
       let touchEndX = 0;
       const minSwipeDistance = 50;
   
       function handleTouchStart(e) {
         if (popupOverlay.hidden) return;
         touchStartX = e.changedTouches[0].screenX;
       }
   
       function handleTouchEnd(e) {
         if (popupOverlay.hidden) return;
         touchEndX = e.changedTouches[0].screenX;
         handleSwipe();
       }
   
       function handleSwipe() {
         const swipeDistance = touchEndX - touchStartX;
         
         if (Math.abs(swipeDistance) < minSwipeDistance) return;
   
         const prevBtn = getPrevButton();
         const nextBtn = getNextButton();
         if (swipeDistance > 0 && prevBtn && !prevBtn.disabled) {
           goPrev();
         } else if (swipeDistance < 0 && nextBtn && !nextBtn.disabled) {
           goNext();
         }
       }
   
       popupOverlay.addEventListener('touchstart', handleTouchStart, { passive: true });
       popupOverlay.addEventListener('touchend', handleTouchEnd, { passive: true });
     });
   }
   
   function initScrollableImagesLooping() {
     const scrollableImageCarousels = document.querySelectorAll('.bk-media-scrollable-images__gallery scroll-carousel');
     
     scrollableImageCarousels.forEach(carousel => {
       const scrollArea = carousel;
       const nextButtons = document.querySelectorAll(`button[is="next-button"][aria-controls="${carousel.id}"]`);
       
       nextButtons.forEach(button => {
         button.addEventListener('click', function(e) {
           const scrollLeft = scrollArea.scrollLeft;
           const scrollWidth = scrollArea.scrollWidth;
           const clientWidth = scrollArea.clientWidth;
           const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
           
           if (isAtEnd) {
             e.preventDefault();
             e.stopPropagation();
             e.stopImmediatePropagation();
             scrollArea.scrollTo({ left: 0, behavior: 'smooth' });
             return false;
           }
         }, { capture: true });
       });
       
       scrollArea.addEventListener('scroll', function() {
         const scrollLeft = scrollArea.scrollLeft;
         const scrollWidth = scrollArea.scrollWidth;
         const clientWidth = scrollArea.clientWidth;
         const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
         
         if (isAtEnd) {
           nextButtons.forEach(btn => {
             btn.disabled = false;
           });
         }
       }, { passive: true });
     });
   }
   
   function initMultiColumnLooping() {
     const multiColumnCarousels = document.querySelectorAll('.shopify-section--multi-column scroll-carousel');
     
     multiColumnCarousels.forEach(carousel => {
       const scrollArea = carousel;
       const nextButtons = document.querySelectorAll(`button[is="next-button"][aria-controls="${carousel.id}"]`);
       
       nextButtons.forEach(button => {
         button.addEventListener('click', function(e) {
           const scrollLeft = scrollArea.scrollLeft;
           const scrollWidth = scrollArea.scrollWidth;
           const clientWidth = scrollArea.clientWidth;
           const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
           
           if (isAtEnd) {
             e.preventDefault();
             e.stopPropagation();
             e.stopImmediatePropagation();
             scrollArea.scrollTo({ left: 0, behavior: 'smooth' });
             return false;
           }
         }, { capture: true });
       });
       
       scrollArea.addEventListener('scroll', function() {
         const scrollLeft = scrollArea.scrollLeft;
         const scrollWidth = scrollArea.scrollWidth;
         const clientWidth = scrollArea.clientWidth;
         const isAtEnd = scrollLeft + clientWidth >= scrollWidth - 1;
         
         if (isAtEnd) {
           nextButtons.forEach(btn => {
             btn.disabled = false;
           });
         }
       }, { passive: true });
     });
   }
   
   document.addEventListener('DOMContentLoaded', function() {
     
     /* ========================================
        INITIALIZE POPUPS
        ======================================== */
     
     initUSPPopups();
     initUSPPopupZoom();
     initMultiColumnPopups();
     initScrollableImagesPopups();
     initScrollableImagesLooping();
     initMultiColumnLooping();
     
     /* ========================================
        GALLERY EXPAND FUNCTIONALITY
        ======================================== */
     
     const expandButtons = document.querySelectorAll('.bk-media-gallery-expand-btn');
     const collapseButtons = document.querySelectorAll('.bk-media-gallery-collapse-btn');
     
     expandButtons.forEach(button => {
       button.addEventListener('click', function() {
         const expandBar = this.closest('.bk-media-gallery-expand-bar');
         const galleryId = expandBar.dataset.galleryId;
         const gallery = document.getElementById(galleryId);
         const hiddenMedia = gallery.querySelectorAll('.bk-media-gallery-hidden');
         const collapseBtn = expandBar.querySelector('.bk-media-gallery-collapse-btn');
         
         gallery.classList.remove('bk-media-gallery-collapsed');
         hiddenMedia.forEach(media => media.classList.remove('bk-media-gallery-hidden'));
         this.style.display = 'none';
         if (collapseBtn) {
           collapseBtn.style.display = 'flex';
         }
       });
     });
     
     collapseButtons.forEach(button => {
       button.addEventListener('click', function() {
         const expandBar = this.closest('.bk-media-gallery-expand-bar');
         const galleryId = expandBar.dataset.galleryId;
         const gallery = document.getElementById(galleryId);
         const allMedia = gallery.querySelectorAll('.product-gallery__media');
         const expandBtn = expandBar.querySelector('.bk-media-gallery-expand-btn');
         
         gallery.classList.add('bk-media-gallery-collapsed');
         allMedia.forEach((media, index) => {
           if (index >= 4) {
             media.classList.add('bk-media-gallery-hidden');
           }
         });
         this.style.display = 'none';
         if (expandBtn) {
           expandBtn.style.display = 'flex';
         }
         
         gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
       });
     });
     
     /* ========================================
        FAQ ACCORDION FUNCTIONALITY
        ======================================== */
     
     function renderFaqHtml() {
       const faqAnswerContents = document.querySelectorAll('.bk-media-faq-answer-content .prose[data-html-content]');
       faqAnswerContents.forEach(content => {
         if (content.dataset.htmlProcessed) return;
         const htmlContent = content.dataset.htmlContent;
         if (htmlContent && htmlContent.includes('&lt;') && htmlContent.includes('&gt;')) {
           const parser = new DOMParser();
           const doc = parser.parseFromString(htmlContent, 'text/html');
           const decodedHtml = doc.documentElement.textContent || doc.documentElement.innerText;
           content.innerHTML = decodedHtml;
           content.removeAttribute('data-html-content');
           content.dataset.htmlProcessed = 'true';
         } else {
           content.dataset.htmlProcessed = 'true';
         }
       });
     }
     
     renderFaqHtml();
     
     const faqButtons = document.querySelectorAll('.bk-media-faq-accordion-btn');
     
     faqButtons.forEach(button => {
       button.addEventListener('click', function() {
         const accordion = this.closest('.bk-media-faq-accordion');
         const answer = accordion.querySelector('.bk-media-faq-answer');
         const isActive = accordion.classList.contains('active');
         
         // Close all other accordions first
         const allAccordions = document.querySelectorAll('.bk-media-faq-accordion');
         allAccordions.forEach(otherAccordion => {
           if (otherAccordion !== accordion) {
             otherAccordion.classList.remove('active');
             const otherAnswer = otherAccordion.querySelector('.bk-media-faq-answer');
             if (otherAnswer) {
               otherAnswer.hidden = true;
             }
           }
         });
         
        // Toggle current accordion
        if (isActive) {
          accordion.classList.remove('active');
          answer.hidden = true;
        } else {
           accordion.classList.add('active');
           answer.hidden = false;
           setTimeout(renderFaqHtml, 0);
           
           // Smooth scroll to the start of the accordion when opening
           if (typeof smoothScrollTo === 'function') {
             setTimeout(() => {
               const scrollOffset = getFAQScrollOffset();
               smoothScrollTo(accordion, { offset: scrollOffset, duration: 1200 });
             }, 100);
           }
         }
       });
     });
     
     /* ========================================
        EXPANDABLE TEXT FUNCTIONALITY
        ======================================== */
     
     const expandableTextToggles = document.querySelectorAll('.bk-media-expandable-text__toggle');
     
     expandableTextToggles.forEach(toggle => {
       toggle.addEventListener('click', function() {
         const expandableText = this.closest('.bk-media-expandable-text');
         const isExpanded = expandableText.classList.contains('is-expanded');
         const expandText = this.getAttribute('data-expand-text');
         const collapseText = this.getAttribute('data-collapse-text');
         
         if (isExpanded) {
           expandableText.classList.remove('is-expanded');
           this.textContent = expandText;
         } else {
           expandableText.classList.add('is-expanded');
           this.textContent = collapseText;
         }
       });
     });
     
     /* ========================================
        THUMBNAILS BOTTOM LAYOUT USP BANNER HANDLING
        ======================================== */
     
     // USP banners are now shown via CSS for all images
     // No JavaScript needed - CSS handles showing all banners
     
     /* ========================================
        PRODUCT GALLERY IMAGE POPUP TRIGGERS
        ======================================== */
     
    // Helper function to trigger USP popup
    function triggerUSPPopup(popupIndex, overlayId) {
      const popupOverlay = overlayId ? document.getElementById(overlayId) : document.getElementById('bk-media-usp-popup-overlay');
      if (!popupOverlay) return;
       
       const panels = Array.from(document.querySelectorAll('[data-popup-panel]'));
       const dots = Array.from(popupOverlay.querySelectorAll('[data-popup-dot]'));
       
       const parsed = typeof popupIndex === 'string' ? parseInt(popupIndex, 10) : popupIndex;
       const index = isNaN(parsed) ? 0 : parsed;
       const boundedIndex = Math.max(0, Math.min(index, panels.length - 1));
       
       // Hide all panels
       panels.forEach(panel => {
         panel.style.display = 'none';
       });
       
       // Show target panel
       const target = panels[boundedIndex];
       if (target) {
         target.style.display = 'block';
       }
       
       // Update dots
       dots.forEach(dot => {
         const idx = parseInt(dot.getAttribute('data-popup-dot'), 10);
         dot.setAttribute('aria-current', idx === boundedIndex ? 'true' : 'false');
       });
       
       // Update button states
       if (typeof window.updateUSPPopupButtonStates === 'function') {
         window.updateUSPPopupButtonStates(boundedIndex);
       }
       
       // Show popup
       popupOverlay.hidden = false;
       document.body.style.overflow = 'hidden';
     }
     
     function initProductGalleryImagePopups() {
       // Find all product galleries
       const productGalleries = document.querySelectorAll('product-gallery');
       
       productGalleries.forEach(gallery => {
         // Find media carousels within the gallery
         const mediaCarousels = gallery.querySelectorAll('media-carousel');
         
         mediaCarousels.forEach(carousel => {
           // Add click handler for left/right navigation and popup triggers
           carousel.addEventListener('click', function(event) {
             const clickedElement = event.target;
             const mediaItem = clickedElement.closest('.product-gallery__media');
             
            // Check if clicking on interactive elements (buttons, links, etc.)
            if (clickedElement.matches('button, a[href], button :scope, a[href] :scope')) {
              return;
            }
             
            // If clicking on a media item, trigger popup
            if (mediaItem) {
              event.preventDefault();
              event.stopPropagation();
              
              // Check if media item has popup triggers
              const isDesktop = window.matchMedia('(min-width: 1000px)').matches;
              const isMobile = window.matchMedia('(max-width: 999px)').matches;
              
              let popupIndex = null;
              const overlayId = mediaItem.getAttribute('data-popup-overlay-id');
              
              if (isDesktop && mediaItem.hasAttribute('data-popup-trigger-desktop')) {
                popupIndex = mediaItem.getAttribute('data-popup-trigger-desktop');
              } else if (isMobile && mediaItem.hasAttribute('data-popup-trigger-mobile')) {
                popupIndex = mediaItem.getAttribute('data-popup-trigger-mobile');
              }
              
              // Trigger popup if we have a valid index
              if (popupIndex !== null && overlayId) {
                triggerUSPPopup(popupIndex, overlayId);
              }
            }
           }, { capture: true });
         });
       });
     }
     
     // Initialize popup triggers on initial load
     initProductGalleryImagePopups();
     
     initUSPPopups();
     initUSPPopupZoom();
     initScrollableImagesPopups();
     initScrollableImagesLooping();
     initMultiColumnLooping();
   });
   
   /* ========================================
      SHOPIFY SECTION RELOAD SUPPORT
      ======================================== */
   
   document.addEventListener('shopify:section:load', function() {
     const expandButtons = document.querySelectorAll('.bk-media-gallery-expand-btn');
     const collapseButtons = document.querySelectorAll('.bk-media-gallery-collapse-btn');
     
     expandButtons.forEach(button => {
       button.addEventListener('click', function() {
         const expandBar = this.closest('.bk-media-gallery-expand-bar');
         const galleryId = expandBar.dataset.galleryId;
         const gallery = document.getElementById(galleryId);
         const hiddenMedia = gallery.querySelectorAll('.bk-media-gallery-hidden');
         const collapseBtn = expandBar.querySelector('.bk-media-gallery-collapse-btn');
         
         gallery.classList.remove('bk-media-gallery-collapsed');
         hiddenMedia.forEach(media => media.classList.remove('bk-media-gallery-hidden'));
         this.style.display = 'none';
         if (collapseBtn) {
           collapseBtn.style.display = 'flex';
         }
       });
     });
     
     collapseButtons.forEach(button => {
       button.addEventListener('click', function() {
         const expandBar = this.closest('.bk-media-gallery-expand-bar');
         const galleryId = expandBar.dataset.galleryId;
         const gallery = document.getElementById(galleryId);
         const allMedia = gallery.querySelectorAll('.product-gallery__media');
         const expandBtn = expandBar.querySelector('.bk-media-gallery-expand-btn');
         
         gallery.classList.add('bk-media-gallery-collapsed');
         allMedia.forEach((media, index) => {
           if (index >= 4) {
             media.classList.add('bk-media-gallery-hidden');
           }
         });
         this.style.display = 'none';
         if (expandBtn) {
           expandBtn.style.display = 'flex';
         }
         
         gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
       });
     });
     
     const faqButtons = document.querySelectorAll('.bk-media-faq-accordion-btn');
     
     faqButtons.forEach(button => {
       button.addEventListener('click', function() {
         const accordion = this.closest('.bk-media-faq-accordion');
         const answer = accordion.querySelector('.bk-media-faq-answer');
         const isActive = accordion.classList.contains('active');
         
        if (isActive) {
          accordion.classList.remove('active');
          answer.hidden = true;
        } else {
           accordion.classList.add('active');
           answer.hidden = false;
           
           // Smooth scroll to the start of the accordion when opening
           if (typeof smoothScrollTo === 'function') {
             setTimeout(() => {
               const scrollOffset = getFAQScrollOffset();
               smoothScrollTo(accordion, { offset: scrollOffset, duration: 1200 });
             }, 100);
           }
         }
       });
     });
     
     const expandableTextToggles = document.querySelectorAll('.bk-media-expandable-text__toggle');
     
     expandableTextToggles.forEach(toggle => {
       toggle.addEventListener('click', function() {
         const expandableText = this.closest('.bk-media-expandable-text');
         const isExpanded = expandableText.classList.contains('is-expanded');
         const expandText = this.getAttribute('data-expand-text');
         const collapseText = this.getAttribute('data-collapse-text');
         
         if (isExpanded) {
           expandableText.classList.remove('is-expanded');
           this.textContent = expandText;
         } else {
           expandableText.classList.add('is-expanded');
           this.textContent = collapseText;
         }
       });
     });
     
     // USP banners are now shown via CSS for all images
     
     /* ========================================
        PRODUCT GALLERY IMAGE POPUP TRIGGERS
        ======================================== */
     
    // Helper function to trigger USP popup
    function triggerUSPPopup(popupIndex, overlayId) {
      const popupOverlay = overlayId ? document.getElementById(overlayId) : document.getElementById('bk-media-usp-popup-overlay');
      if (!popupOverlay) return;
       
       const panels = Array.from(document.querySelectorAll('[data-popup-panel]'));
       const dots = Array.from(popupOverlay.querySelectorAll('[data-popup-dot]'));
       
       const parsed = typeof popupIndex === 'string' ? parseInt(popupIndex, 10) : popupIndex;
       const index = isNaN(parsed) ? 0 : parsed;
       const boundedIndex = Math.max(0, Math.min(index, panels.length - 1));
       
       // Hide all panels
       panels.forEach(panel => {
         panel.style.display = 'none';
       });
       
       // Show target panel
       const target = panels[boundedIndex];
       if (target) {
         target.style.display = 'block';
       }
       
       // Update dots
       dots.forEach(dot => {
         const idx = parseInt(dot.getAttribute('data-popup-dot'), 10);
         dot.setAttribute('aria-current', idx === boundedIndex ? 'true' : 'false');
       });
       
       // Update button states
       if (typeof window.updateUSPPopupButtonStates === 'function') {
         window.updateUSPPopupButtonStates(boundedIndex);
       }
       
       // Show popup
       popupOverlay.hidden = false;
       document.body.style.overflow = 'hidden';
     }
     
     function initProductGalleryImagePopups() {
       // Find all product galleries
       const productGalleries = document.querySelectorAll('product-gallery');
       
       productGalleries.forEach(gallery => {
         // Find media carousels within the gallery
         const mediaCarousels = gallery.querySelectorAll('media-carousel');
         
         mediaCarousels.forEach(carousel => {
           // Add click handler to trigger popup on image clicks
           carousel.addEventListener('click', function(event) {
             const clickedElement = event.target;
             const mediaItem = clickedElement.closest('.product-gallery__media');
             
            // Check if clicking on interactive elements (buttons, links, etc.)
            if (clickedElement.matches('button, a[href], button :scope, a[href] :scope')) {
              return;
            }
             
            // If clicking on a media item, trigger popup
            if (mediaItem) {
              event.preventDefault();
              event.stopPropagation();
              
              // Check if media item has popup triggers
              const isDesktop = window.matchMedia('(min-width: 1000px)').matches;
              const isMobile = window.matchMedia('(max-width: 999px)').matches;
              
              let popupIndex = null;
              const overlayId = mediaItem.getAttribute('data-popup-overlay-id');
              
              if (isDesktop && mediaItem.hasAttribute('data-popup-trigger-desktop')) {
                popupIndex = mediaItem.getAttribute('data-popup-trigger-desktop');
              } else if (isMobile && mediaItem.hasAttribute('data-popup-trigger-mobile')) {
                popupIndex = mediaItem.getAttribute('data-popup-trigger-mobile');
              }
              
              // Trigger popup if we have a valid index
              if (popupIndex !== null && overlayId) {
                triggerUSPPopup(popupIndex, overlayId);
              }
            }
           }, { capture: true });
         });
       });
     }
     
     // Initialize popup triggers on section load
     initProductGalleryImagePopups();
     
     initUSPPopups();
     initUSPPopupZoom();
     initScrollableImagesPopups();
     initScrollableImagesLooping();
     initMultiColumnLooping();
   });
   
   /* ========================================
      BLOG TAG SWITCHER DATA FIX
      ======================================== */
   
   function initBlogTagSwitcher() {
     const tagDataScript = document.querySelector('[data-blog-tag-data]');
     if (!tagDataScript) return;
     
     let tagData = {};
     try {
       tagData = JSON.parse(tagDataScript.textContent);
     } catch (e) {
       console.error('Failed to parse blog tag data:', e);
       return;
     }
     
     const currentUrl = window.location.href;
     const isTaggedPage = currentUrl.includes('/tagged/');
     
     if (isTaggedPage && tagData.blogUrl) {
       fetch(tagData.blogUrl)
         .then(response => {
           if (!response.ok) {
             throw new Error('Failed to fetch blog data');
           }
           return response.text();
         })
         .then(html => {
           const parser = new DOMParser();
           const doc = parser.parseFromString(html, 'text/html');
           const fetchedTagDataScript = doc.querySelector('[data-blog-tag-data]');
           if (fetchedTagDataScript) {
             try {
               const fetchedTagData = JSON.parse(fetchedTagDataScript.textContent);
               updateTagSwitcherData(fetchedTagData);
             } catch (e) {
               console.error('Failed to parse fetched tag data:', e);
               updateTagSwitcherData(tagData);
             }
           } else {
             updateTagSwitcherData(tagData);
           }
         })
         .catch(error => {
           console.error('Error fetching blog data:', error);
           updateTagSwitcherData(tagData);
         });
     } else {
       updateTagSwitcherData(tagData);
     }
     
     function updateTagSwitcherData(data) {
       const tagItems = document.querySelectorAll('.bk-media-blog-tag-switcher__item');
       
       tagItems.forEach(item => {
         const tagName = item.querySelector('h3')?.textContent?.trim();
         if (!tagName) return;
         
         if (tagName === 'Alle Artikel' || tagName === 'All Posts') {
           if (data.allArticlesCount !== undefined) {
             const countElement = item.querySelector('.text-subdued');
             if (countElement) {
               const count = data.allArticlesCount;
               const existingText = countElement.textContent;
               countElement.textContent = existingText.replace(/\d+/, count.toString());
             }
           }
           return;
         }
         
         const tagInfo = data.tags[tagName];
         if (!tagInfo) return;
         
         const countElement = item.querySelector('.text-subdued');
         if (countElement && tagInfo.count !== undefined) {
           const count = tagInfo.count;
           const existingText = countElement.textContent;
           countElement.textContent = existingText.replace(/\d+/, count.toString());
         }
         
         const imageWrapper = item.querySelector('.bk-media-blog-tag-switcher__image');
         if (imageWrapper && tagInfo.imageUrl) {
           const hasBlockImage = item.id && item.id.startsWith('block-');
           if (!hasBlockImage) {
             const existingImg = imageWrapper.querySelector('img');
             const placeholder = imageWrapper.querySelector('.placeholder-svg');
             
             if (placeholder) {
               const img = document.createElement('img');
               img.src = tagInfo.imageUrl;
               img.alt = tagName;
               img.loading = 'lazy';
               img.sizes = '(max-width: 699px) 100vw, 50vw';
               img.srcset = tagInfo.imageUrl.replace('_800x', '_200x') + ' 200w, ' +
                            tagInfo.imageUrl.replace('_800x', '_300x') + ' 300w, ' +
                            tagInfo.imageUrl.replace('_800x', '_400x') + ' 400w, ' +
                            tagInfo.imageUrl.replace('_800x', '_500x') + ' 500w, ' +
                            tagInfo.imageUrl.replace('_800x', '_600x') + ' 600w, ' +
                            tagInfo.imageUrl + ' 800w';
               img.width = 800;
               img.height = 600;
               placeholder.replaceWith(img);
             } else if (existingImg && (!existingImg.src || existingImg.src.includes('placeholder') || existingImg.src !== tagInfo.imageUrl)) {
               existingImg.src = tagInfo.imageUrl;
               existingImg.alt = tagName;
               existingImg.srcset = tagInfo.imageUrl.replace('_800x', '_200x') + ' 200w, ' +
                                   tagInfo.imageUrl.replace('_800x', '_300x') + ' 300w, ' +
                                   tagInfo.imageUrl.replace('_800x', '_400x') + ' 400w, ' +
                                   tagInfo.imageUrl.replace('_800x', '_500x') + ' 500w, ' +
                                   tagInfo.imageUrl.replace('_800x', '_600x') + ' 600w, ' +
                                   tagInfo.imageUrl + ' 800w';
             } else if (!existingImg) {
               const img = document.createElement('img');
               img.src = tagInfo.imageUrl;
               img.alt = tagName;
               img.loading = 'lazy';
               img.sizes = '(max-width: 699px) 100vw, 50vw';
               img.srcset = tagInfo.imageUrl.replace('_800x', '_200x') + ' 200w, ' +
                            tagInfo.imageUrl.replace('_800x', '_300x') + ' 300w, ' +
                            tagInfo.imageUrl.replace('_800x', '_400x') + ' 400w, ' +
                            tagInfo.imageUrl.replace('_800x', '_500x') + ' 500w, ' +
                            tagInfo.imageUrl.replace('_800x', '_600x') + ' 600w, ' +
                            tagInfo.imageUrl + ' 800w';
               img.width = 800;
               img.height = 600;
               imageWrapper.appendChild(img);
             }
           }
         }
       });
     }
   
   }
   
   function scrollTagCarouselToActive() {
     const tagSwitcher = document.querySelector('.bk-media-blog-tag-switcher');
     if (!tagSwitcher) return;
     
     const scrollCarousel = tagSwitcher.closest('scroll-carousel');
     if (!scrollCarousel) return;
     
     function attemptScroll() {
       if (!scrollCarousel.items || scrollCarousel.items.length === 0) {
         return false;
       }
       
       let activeIndex = -1;
       scrollCarousel.items.forEach((item, index) => {
         if (item.classList.contains('is-active') || item.getAttribute('aria-current') === 'page') {
           activeIndex = index;
         }
       });
       
       if (activeIndex >= 0 && typeof scrollCarousel.select === 'function') {
         scrollCarousel.select(activeIndex, { animate: false });
         return true;
       }
       
       return false;
     }
     
     if (!attemptScroll()) {
       setTimeout(function() {
         if (!attemptScroll()) {
           setTimeout(attemptScroll, 200);
         }
       }, 100);
     }
   }
   
   function scrollCollectionCarouselToActive() {
     const collectionSwitcher = document.querySelector('.bk-media-collection-switcher');
     if (!collectionSwitcher) return;
     
     const scrollCarousel = collectionSwitcher.closest('scroll-carousel');
     if (!scrollCarousel) return;
     
     function attemptScroll() {
       if (!scrollCarousel.items || scrollCarousel.items.length === 0) {
         return false;
       }
       
       let activeIndex = -1;
       scrollCarousel.items.forEach((item, index) => {
         if (item.classList.contains('is-active') || item.getAttribute('aria-current') === 'page') {
           activeIndex = index;
         }
       });
       
       if (activeIndex >= 0 && typeof scrollCarousel.select === 'function') {
         scrollCarousel.select(activeIndex, { animate: true });
         return true;
       }
       
       return false;
     }
     
     if (!attemptScroll()) {
       setTimeout(function() {
         if (!attemptScroll()) {
           setTimeout(attemptScroll, 200);
         }
       }, 100);
     }
   }
   
   function initBlogTagScroll() {
     const tagLinks = document.querySelectorAll('.bk-media-blog-tag-switcher__item[href]');
     
     tagLinks.forEach(link => {
       link.addEventListener('click', function(e) {
         sessionStorage.setItem('bk-media-blog-tag-clicked', 'true');
       });
     });
     
     const shouldScroll = sessionStorage.getItem('bk-media-blog-tag-clicked');
     
     if (shouldScroll) {
       sessionStorage.removeItem('bk-media-blog-tag-clicked');
       
       function scrollToBlogSection() {
         scrollTagCarouselToActive();
         
         const blogHeading = document.querySelector('.bk-media-blog-heading');
         const blogBanner = document.querySelector('.blog-banner');
         const scrollTarget = blogHeading || blogBanner;
         
         if (scrollTarget && typeof smoothScrollTo === 'function') {
           smoothScrollTo(scrollTarget, { offset: 20, duration: 1200 });
         }
       }
       
       if (document.readyState === 'complete') {
         setTimeout(scrollToBlogSection, 300);
       } else {
         window.addEventListener('load', function() {
           setTimeout(scrollToBlogSection, 300);
         });
       }
     } else {
       setTimeout(scrollTagCarouselToActive, 100);
     }
   }
   
   function initProductCardClickable() {
     const productCards = document.querySelectorAll('product-card');
     
     productCards.forEach(card => {
       const productLink = card.querySelector('.product-card__title a, .product-card__figure a');
       if (!productLink) return;
       
       const productUrl = productLink.href;
       const quickBuyArea = card.querySelector('.product-card__quick-buy');
       
       card.style.cursor = 'pointer';
       
       card.addEventListener('click', function(e) {
         const clickedElement = e.target;
         const isQuickBuy = quickBuyArea && (
           quickBuyArea.contains(clickedElement) ||
           clickedElement.closest('.product-card__quick-buy') ||
           clickedElement.closest('form') ||
           clickedElement.closest('button') ||
           clickedElement.closest('quick-buy-drawer')
         );
         
         if (!isQuickBuy && !clickedElement.closest('a')) {
           e.preventDefault();
           window.location.href = productUrl;
         }
       });
       
       if (quickBuyArea) {
         quickBuyArea.addEventListener('click', function(e) {
           e.stopPropagation();
         });
       }
     });
   }
   
   document.addEventListener('DOMContentLoaded', function() {
     initBlogTagSwitcher();
     initBlogTagScroll();
     scrollCollectionCarouselToActive();
     initProductCardClickable();
   });
   
   document.addEventListener('shopify:section:load', function() {
     initBlogTagSwitcher();
     initBlogTagScroll();
     scrollCollectionCarouselToActive();
     initProductCardClickable();
   });
   
   document.addEventListener('shopify:section:reorder', function() {
     setTimeout(scrollTagCarouselToActive, 100);
     setTimeout(scrollCollectionCarouselToActive, 100);
   });
   
   /* ========================================
      SLIDESHOW AUTOPLAY STOP ON MANUAL NAVIGATION
      ======================================== */
   
   function initSlideshowAutoplayStop() {
     const slideshowCarousels = document.querySelectorAll('slideshow-carousel[autoplay]');
     
     slideshowCarousels.forEach(carousel => {
       let autoplayStopped = false;
       
       // Function to stop autoplay permanently
       function stopAutoplay() {
         if (!autoplayStopped) {
           autoplayStopped = true;
           if (carousel.player) {
             carousel.player.stop();
           }
           carousel.removeAttribute('autoplay');
           
           // Override player resume to prevent restarting
           if (carousel.player && carousel.player.resume) {
             const originalResume = carousel.player.resume.bind(carousel.player);
             carousel.player.resume = function() {
               // Do nothing if autoplay was stopped
               return;
             };
           }
         }
       }
       
       // Wait for carousel to be fully connected and player initialized
       const checkAndSetup = () => {
         if (carousel.player) {
           // Override player resume method to prevent restarting after manual navigation
           const originalResume = carousel.player.resume;
           carousel.player.resume = function(restartTimer) {
             if (!autoplayStopped) {
               return originalResume.call(this, restartTimer);
             }
             // If autoplay was stopped, don't resume
             return;
           };
         }
       };
       
       // Try to setup immediately
       checkAndSetup();
       
       // Also try after a short delay in case player isn't ready yet
       setTimeout(checkAndSetup, 100);
       
       // Listen for manual navigation events
       carousel.addEventListener('control:prev', stopAutoplay, { once: false });
       carousel.addEventListener('control:next', stopAutoplay, { once: false });
       carousel.addEventListener('control:select', stopAutoplay, { once: false });
       carousel.addEventListener('swipeleft', stopAutoplay, { once: false });
       carousel.addEventListener('swiperight', stopAutoplay, { once: false });
       
       // Also listen for tap events (for custom cursor navigation)
       carousel.addEventListener('tap', function(event) {
         // Only stop if it's not clicking on a button or link
         if (!event.target.matches('button, a[href], button :scope, a[href] :scope')) {
           stopAutoplay();
         }
       }, { once: false });
     });
   }
   
   /* ========================================
      SLIDESHOW ENABLE SWIPING ON MOBILE
      ======================================== */
   
   function initSlideshowEnableMobileSwipe() {
     const slideshowCarousels = document.querySelectorAll('slideshow-carousel');
     
     slideshowCarousels.forEach(carousel => {
       // Ensure swipeable is enabled (remove any false attribute)
       if (carousel.getAttribute('swipeable') === 'false') {
         carousel.removeAttribute('swipeable');
       }
       
       // Make sure swipe events are not prevented
       // The theme should handle this by default, but we ensure it's enabled
     });
   }
   
   // Initialize on DOM ready
   document.addEventListener('DOMContentLoaded', function() {
     initSlideshowAutoplayStop();
     initSlideshowEnableMobileSwipe();
   });
   
   // Re-initialize when sections are loaded/reloaded
   document.addEventListener('shopify:section:load', function() {
     setTimeout(function() {
       initSlideshowAutoplayStop();
       initSlideshowEnableMobileSwipe();
     }, 100);
   });
   
   /* ========================================
      CART DRAWER VAT CALCULATION
      ======================================== */
   
   let cartDrawerVatObserver = null;
   
   function updateCartDrawerVat() {
     const cartDrawer = document.querySelector('cart-drawer');
     if (!cartDrawer) return;
     
     const totalElement = cartDrawer.querySelector('[data-hulkapps-cart-total]');
     const vatAmountElement = cartDrawer.querySelector('#cart-drawer-vat-amount');
     
     if (!totalElement || !vatAmountElement) {
       return;
     }
     
     const totalText = totalElement.textContent.trim();
     const totalMatch = totalText.match(/[\d.,]+/);
     if (!totalMatch) {
       return;
     }
     
     let totalValueStr = totalMatch[0];
     let totalValue;
     if (totalValueStr.includes(',')) {
       totalValue = parseFloat(totalValueStr.replace(/\./g, '').replace(',', '.'));
     } else {
       totalValue = parseFloat(totalValueStr.replace(/,/g, ''));
     }
     
     if (isNaN(totalValue)) {
       return;
     }
     
    const vatAmount = (totalValue / 1.19) * 0.19;
    const vatParts = vatAmount.toFixed(2).split('.');
    const integerPart = vatParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const vatFormatted = integerPart + ',' + vatParts[1];
    vatAmountElement.textContent = vatFormatted;
   }
   
   function setupCartDrawerVatObserver() {
     const cartDrawer = document.querySelector('cart-drawer');
     if (!cartDrawer) return;
     
     if (cartDrawerVatObserver) {
       cartDrawerVatObserver.disconnect();
     }
     
     const totalElement = cartDrawer.querySelector('[data-hulkapps-cart-total]');
     if (!totalElement) return;
     
     cartDrawerVatObserver = new MutationObserver(() => {
       updateCartDrawerVat();
     });
     
     cartDrawerVatObserver.observe(totalElement, {
       childList: true,
       characterData: true,
       subtree: true
     });
     
     updateCartDrawerVat();
   }
   
   function initCartDrawerVat() {
     setTimeout(() => {
       setupCartDrawerVatObserver();
     }, 100);
   }
   
   // Initialize on DOM ready
   document.addEventListener('DOMContentLoaded', function() {
     initCartDrawerVat();
   });
   
   // Update when cart changes
   document.addEventListener('cart:change', function() {
     setTimeout(() => {
       setupCartDrawerVatObserver();
     }, 1350);
   });
   
   // Update when variant is added
   document.addEventListener('variant:add', function() {
     setTimeout(() => {
       setupCartDrawerVatObserver();
     }, 100);
   });
   
   // Re-initialize when sections are loaded/reloaded
   document.addEventListener('shopify:section:load', function() {
     setTimeout(function() {
       initCartDrawerVat();
     }, 100);
   });
   
   /* ========================================
      CART DRAWER REMOVE PREVENT NAVIGATION
      ======================================== */
   
   function initCartDrawerRemovePrevention() {
     const cartDrawer = document.querySelector('cart-drawer');
     if (!cartDrawer) return;
     
     function handleRemoveClick(e) {
       const removeLink = e.target.closest('a[href*="cart/change"], a[href*="url_to_remove"]');
       if (!removeLink) return;
       
       const isInCartDrawer = cartDrawer.contains(removeLink);
       if (!isInCartDrawer) return;
       
       e.preventDefault();
       e.stopPropagation();
       
       try {
         const url = new URL(removeLink.href, window.location.origin);
         const lineKey = url.searchParams.get('id');
         
         if (!lineKey) return;
         
         const lineItem = removeLink.closest('line-item');
         lineItem?.dispatchEvent(new CustomEvent('line-item:will-change', { bubbles: true, detail: { targetQuantity: 0 } }));
         
         let sectionsToBundle = [];
         document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
         
         fetch(`${Shopify.routes.root}cart/change.js`, {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json'
           },
           body: JSON.stringify({
             id: lineKey,
             quantity: 0,
             sections: sectionsToBundle
           })
         }).then(async (response) => {
           if (!response.ok) {
             const responseContent = await response.json();
             lineItem?.dispatchEvent(new CustomEvent('line-item:error', { bubbles: true }));
             console.error('Cart update error:', responseContent);
           } else {
             const cartContent = await response.json();
             const lineItemAfterChange = cartContent.items.filter((item) => item.key === lineKey);
             lineItem?.dispatchEvent(new CustomEvent('line-item:change', {
               bubbles: true,
               detail: {
                 quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0].quantity,
                 cart: cartContent
               }
             }));
             document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
               bubbles: true,
               detail: {
                 baseEvent: 'line-item:change',
                 cart: cartContent
               }
             }));
           }
         }).catch((error) => {
           console.error('Cart update error:', error);
           lineItem?.dispatchEvent(new CustomEvent('line-item:error', { bubbles: true }));
         });
       } catch (error) {
         console.error('Error parsing remove URL:', error);
       }
     }
     
     cartDrawer.addEventListener('click', handleRemoveClick);
   }
   
   document.addEventListener('DOMContentLoaded', function() {
     initCartDrawerRemovePrevention();
   });
   
   document.addEventListener('shopify:section:load', function() {
     setTimeout(function() {
       initCartDrawerRemovePrevention();
     }, 100);
   });
   
   /* ========================================
      NEWSLETTER POPUP NON-BLOCKING SCROLL
      ======================================== */
   
   function initNewsletterPopupNonBlocking() {
     const newsletterPopup = document.querySelector('newsletter-popup.newsletter-drawer');
     if (!newsletterPopup) return;
   
     const observer = new MutationObserver(function(mutations) {
       mutations.forEach(function(mutation) {
         if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
           if (newsletterPopup.hasAttribute('open')) {
             document.documentElement.classList.remove('lock');
           }
         }
       });
     });
   
     observer.observe(newsletterPopup, {
       attributes: true,
       attributeFilter: ['open']
     });
   
     const lockObserver = new MutationObserver(function(mutations) {
       mutations.forEach(function(mutation) {
         if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
           if (document.documentElement.classList.contains('lock') && newsletterPopup.hasAttribute('open')) {
             document.documentElement.classList.remove('lock');
           }
         }
       });
     });
   
     lockObserver.observe(document.documentElement, {
       attributes: true,
       attributeFilter: ['class']
     });
   }
   
   document.addEventListener('DOMContentLoaded', function() {
     initNewsletterPopupNonBlocking();
   });
   
  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() {
      initNewsletterPopupNonBlocking();
    }, 100);
  });

  /* ========================================
     EXIT INTENT POPUP
     ======================================== */

  const EXIT_INTENT_SESSION_PREFIX = 'bk-media-exit-intent-shown-';

  function initExitIntentPopup() {
    const popup = document.querySelector('.bk-media-exit-intent-popup');
    if (!popup || popup.hasAttribute('data-exit-intent-initialized')) return;
    popup.setAttribute('data-exit-intent-initialized', 'true');

    const showOncePerSession = popup.getAttribute('data-show-once-per-session') === 'true';
    const enableOnMobile = popup.getAttribute('data-enable-on-mobile') === 'true';
    const productHandle = popup.getAttribute('data-product-handle') || '';
    const sessionKey = productHandle ? EXIT_INTENT_SESSION_PREFIX + productHandle : EXIT_INTENT_SESSION_PREFIX + 'default';
    const overlay = popup.querySelector('.bk-media-exit-intent-popup__overlay');
    const closeBtn = popup.querySelector('.bk-media-exit-intent-popup__close');

    function isMobile() {
      return window.matchMedia('(max-width: 699px)').matches;
    }

    function shouldShow() {
      if (showOncePerSession && sessionStorage.getItem(sessionKey) === 'true') {
        return false;
      }
      if (!enableOnMobile && isMobile()) {
        return false;
      }
      return true;
    }

    function show() {
      if (!shouldShow()) return;
      popup.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      if (showOncePerSession) {
        sessionStorage.setItem(sessionKey, 'true');
      }
    }

    function hide() {
      popup.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    function isDrawerOrPopupOpen() {
      const drawers = document.querySelectorAll('cart-drawer, search-drawer, navigation-drawer, x-drawer, quick-buy-drawer, newsletter-popup, facet-drawer');
      if (Array.from(drawers).some(function(el) { return el.hasAttribute && el.hasAttribute('open'); })) return true;
      const uspPopup = document.querySelector('.bk-media-usp-popup');
      if (uspPopup && !uspPopup.hasAttribute('hidden')) return true;
      return false;
    }

    function isWithinDrawerOrPopup(el) {
      if (!el || !el.nodeType) return false;
      var root = el.getRootNode && el.getRootNode();
      var host = root && root.host;
      var checkEl = host || el;
      var tag = checkEl.tagName && checkEl.tagName.toLowerCase();
      var drawerTags = ['cart-drawer', 'search-drawer', 'navigation-drawer', 'quick-buy-drawer', 'newsletter-popup', 'facet-drawer', 'x-drawer'];
      if (drawerTags.indexOf(tag) >= 0) return true;
      if (checkEl.closest && checkEl.closest('cart-drawer, search-drawer, navigation-drawer, x-drawer, quick-buy-drawer, newsletter-popup, facet-drawer, .bk-media-usp-popup, .bk-media-exit-intent-popup')) return true;
      return false;
    }

    var drawerOpenIgnoreUntil = 0;
    document.addEventListener('click', function(e) {
      var target = e.target;
      var trigger = target.closest && target.closest(
        '[aria-controls="cart-drawer"], [aria-controls="search-drawer"], [aria-controls*="drawer"], [aria-controls="header-sidebar-menu"], ' +
        '[data-popup-trigger], [data-popup-trigger-desktop], [data-popup-trigger-mobile], ' +
        '.bk-media-usp-popup, .bk-media-usp-banner, .rating, .jdgm-widget, .jdgm-preview-badge, ' +
        'a[href*="#shopify-product-reviews"]'
      );
      if (trigger) {
        drawerOpenIgnoreUntil = Date.now() + 1000;
      }
    }, true);

    function handleExitIntent(e) {
      if (e.clientY > 0) return;
      if (drawerOpenIgnoreUntil > Date.now()) return;
      if (isDrawerOrPopupOpen()) return;
      var rel = e.relatedTarget;
      if (rel && isWithinDrawerOrPopup(rel)) return;
      if (shouldShow()) {
        show();
        document.removeEventListener('mouseout', handleExitIntent);
      }
    }

    function isInputFocused() {
      const el = document.activeElement;
      if (!el) return false;
      const tag = el.tagName && el.tagName.toLowerCase();
      const role = (el.getAttribute && el.getAttribute('role')) || '';
      return tag === 'input' || tag === 'textarea' || tag === 'select' || role === 'combobox' || role === 'listbox';
    }

    let lastWindowArea = window.innerWidth * window.innerHeight;
    let lastScrollTime = 0;
    const RESIZE_SHRINK_RATIO = 0.85;
    const SCROLL_DEBOUNCE_MS = 600;

    function handleWindowBlur() {
      if (isInputFocused()) return;
      if (drawerOpenIgnoreUntil > Date.now()) return;
      if (isDrawerOrPopupOpen()) return;
      if (shouldShow()) {
        show();
        window.removeEventListener('blur', handleWindowBlur);
      }
    }

    function handleVisibilityChange() {
      if (document.hidden && drawerOpenIgnoreUntil <= Date.now() && !isDrawerOrPopupOpen() && shouldShow()) {
        show();
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      }
    }

    function handleMobileResize() {
      const area = window.innerWidth * window.innerHeight;
      if (isInputFocused()) {
        lastWindowArea = area;
        return;
      }
      if (Date.now() - lastScrollTime < SCROLL_DEBOUNCE_MS) {
        lastWindowArea = area;
        return;
      }
      if (area < lastWindowArea * RESIZE_SHRINK_RATIO && shouldShow()) {
        show();
        window.removeEventListener('resize', handleMobileResize);
      }
      lastWindowArea = area;
    }

    function handleScroll() {
      lastScrollTime = Date.now();
    }

    function handleNavigationClick(e) {
      const a = e.target.closest('a[href]');
      if (!a || a.closest('.bk-media-exit-intent-popup')) return;
      if (a.target === '_blank') return;
      const href = (a.getAttribute('href') || '').trim();
      if (!href || href === '#' || href.startsWith('#')) return;
      if (href.startsWith('javascript:')) return;
      if (a.pathname === window.location.pathname && a.search === (window.location.search || '')) return;
      if (a.closest && (a.closest('cart-drawer') || a.closest('search-drawer') || a.closest('navigation-drawer') || a.closest('x-drawer') || a.closest('quick-buy-drawer') || a.closest('newsletter-popup') || a.closest('.bk-media-usp-popup') || a.closest('.rating') || a.closest('.jdgm-widget') || a.closest('.jdgm-preview-badge'))) return;
      if (drawerOpenIgnoreUntil > Date.now()) return;
      if (isDrawerOrPopupOpen()) return;
      if (!shouldShow()) return;
      e.preventDefault();
      e.stopPropagation();
      show();
    }

    document.addEventListener('click', handleNavigationClick, true);

    if (enableOnMobile && isMobile()) {
      window.addEventListener('blur', handleWindowBlur);
      document.addEventListener('visibilitychange', handleVisibilityChange);
      window.addEventListener('resize', handleMobileResize);
      window.addEventListener('scroll', handleScroll, { passive: true });
    } else {
      document.addEventListener('mouseout', handleExitIntent);
    }

    function handleClose(e) {
      e.preventDefault();
      hide();
    }

    if (overlay) overlay.addEventListener('click', handleClose);
    if (closeBtn) closeBtn.addEventListener('click', handleClose);

    document.addEventListener('keydown', function handleEscape(e) {
      if (e.key === 'Escape' && !popup.hasAttribute('hidden')) {
        hide();
      }
    });

    const ctaButton = popup.querySelector('.bk-media-exit-intent-popup__button');
    if (ctaButton) {
      ctaButton.addEventListener('click', function(e) {
        e.preventDefault();
        hide();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    initExitIntentPopup();
  });

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initExitIntentPopup, 100);
  });

  /* ========================================
     ANNOUNCEMENT BAR MOBILE AUTO-CYCLE
     ======================================== */

  function initMobileNavAnnouncementClone() {
    var drawer = document.getElementById('header-sidebar-menu');
    if (!drawer) return;
    var target = drawer.querySelector('[data-bk-mobile-nav-announcement]');
    if (!target) return;
    var sourceSection = document.querySelector('.shopify-section--announcement-bar');
    var sourceBar = sourceSection && sourceSection.querySelector('.announcement-bar');
    if (!sourceBar) {
      target.innerHTML = '';
      return;
    }
    var clone = sourceBar.cloneNode(true);
    var idSuffix = '-mobile-nav';
    var idMap = new Map();
    clone.querySelectorAll('[id]').forEach(function(el) {
      var oldId = el.id;
      if (!oldId) return;
      var newId = oldId + idSuffix;
      idMap.set(oldId, newId);
      el.id = newId;
    });
    clone.querySelectorAll('[aria-controls]').forEach(function(el) {
      var c = el.getAttribute('aria-controls');
      if (c && idMap.has(c)) {
        el.setAttribute('aria-controls', idMap.get(c));
      }
    });
    target.innerHTML = '';
    target.appendChild(clone);
  }

  var announcementMirrorObserver = null;
  var mirrorSyncRaf = null;

  function getSourceAnnouncementBar() {
    return document.querySelector('.shopify-section--announcement-bar announcement-bar.announcement-bar__distributed');
  }

  function getMirrorAnnouncementBar() {
    return document.querySelector('#header-sidebar-menu [data-bk-mobile-nav-announcement] announcement-bar.announcement-bar__distributed');
  }

  function syncAnnouncementMirrorFromSource() {
    var sourceBar = getSourceAnnouncementBar();
    var mirrorBar = getMirrorAnnouncementBar();
    if (!sourceBar || !mirrorBar) return;
    var sourceItems = sourceBar.querySelectorAll('.announcement-bar__distributed-item');
    var mirrorItems = mirrorBar.querySelectorAll('.announcement-bar__distributed-item');
    if (sourceItems.length !== mirrorItems.length) return;
    var sel = sourceBar.getAttribute('selected-index');
    if (sel != null) mirrorBar.setAttribute('selected-index', sel);
    for (var i = 0; i < sourceItems.length; i++) {
      mirrorItems[i].className = sourceItems[i].className;
      mirrorItems[i].style.cssText = sourceItems[i].style.cssText;
    }
    mirrorBar.style.minHeight = sourceBar.style.minHeight || '';
  }

  function scheduleAnnouncementMirrorSync() {
    if (mirrorSyncRaf) return;
    mirrorSyncRaf = requestAnimationFrame(function () {
      mirrorSyncRaf = null;
      syncAnnouncementMirrorFromSource();
    });
  }

  function attachAnnouncementMirrorObserver() {
    if (announcementMirrorObserver) {
      announcementMirrorObserver.disconnect();
      announcementMirrorObserver = null;
    }
    var sourceBar = getSourceAnnouncementBar();
    if (!sourceBar) return;
    announcementMirrorObserver = new MutationObserver(function () {
      scheduleAnnouncementMirrorSync();
    });
    announcementMirrorObserver.observe(sourceBar, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class', 'style', 'selected-index']
    });
  }
  
  function initAnnouncementBarAutoCycle() {
    const announcementBars = document.querySelectorAll('announcement-bar.announcement-bar__distributed');
    
    announcementBars.forEach(function(bar) {
      if (bar.hasAttribute('data-bk-announcement-cycle-init')) return;

      const section = bar.closest('.shopify-section--announcement-bar');
      if (!section) return;
      
      const items = bar.querySelectorAll('.announcement-bar__distributed-item');
      if (items.length !== 3) return;

      bar.setAttribute('data-bk-announcement-cycle-init', '');
      
      const rotationEnabled = bar.getAttribute('data-mobile-rotation-enabled') !== 'false';
      const middleIndex = 1;
      
      let cycleInterval = null;
      let cycleTimeout = null;
      let cycleIndex = 0;
      let isUpdatingVisibility = false;
      const cycleOrder = [1, 0, 2];
      
      function getRotationSpeed() {
        const mobileRotationSpeed = parseFloat(bar.getAttribute('data-mobile-rotation-speed')) || 2;
        return mobileRotationSpeed * 1000;
      }
      
      function setToMiddle(noAnimation) {
        if (noAnimation) {
          items.forEach(function(item, index) {
            item.style.removeProperty('opacity');
            item.style.removeProperty('visibility');
            item.style.removeProperty('pointer-events');
            item.style.removeProperty('transform');
            item.classList.add('bk-media-announcement-no-transition');
            item.style.setProperty('display', 'flex', 'important');
            
            if (index === middleIndex) {
              item.classList.remove('bk-media-announcement-hidden', 'bk-media-announcement-entering');
              item.classList.add('bk-media-announcement-visible');
            } else {
              item.classList.remove('bk-media-announcement-visible', 'bk-media-announcement-entering');
              item.classList.add('bk-media-announcement-hidden');
            }
          });
          
          requestAnimationFrame(function() {
            items.forEach(function(item) {
              item.classList.remove('bk-media-announcement-no-transition');
            });
          });
        } else {
          updateItemVisibility(middleIndex);
        }
        
        if (bar.select && typeof bar.select === 'function') {
          bar.select(middleIndex, { animate: false });
        }
        
        bar.setAttribute('selected-index', middleIndex.toString());
      }
      
      function hideNonMiddleItems() {
        items.forEach(function(item, index) {
          item.style.removeProperty('opacity');
          item.style.removeProperty('visibility');
          item.style.removeProperty('pointer-events');
          item.style.removeProperty('transform');
          item.classList.remove('bk-media-announcement-no-transition');
          
          if (index !== middleIndex) {
            item.classList.remove('bk-media-announcement-visible', 'bk-media-announcement-entering');
            item.classList.add('bk-media-announcement-hidden');
            item.style.setProperty('display', 'flex', 'important');
          } else {
            item.classList.remove('bk-media-announcement-hidden', 'bk-media-announcement-entering');
            item.classList.add('bk-media-announcement-visible');
            item.style.setProperty('display', 'flex', 'important');
          }
        });
      }
      
      function showAllItems() {
        items.forEach(function(item, index) {
          item.style.removeProperty('opacity');
          item.style.removeProperty('visibility');
          item.style.removeProperty('pointer-events');
          item.style.removeProperty('display');
          item.style.removeProperty('transform');
        });
      }
      
      function updateItemVisibility(visibleIndex, skipObserver) {
        if (isUpdatingVisibility && !skipObserver) return;
        
        if (!skipObserver) {
          isUpdatingVisibility = true;
        }
        
        items.forEach(function(item, index) {
          item.style.removeProperty('opacity');
          item.style.removeProperty('visibility');
          item.style.removeProperty('pointer-events');
          item.style.removeProperty('transform');
          item.classList.remove('bk-media-announcement-no-transition');
          item.style.setProperty('display', 'flex', 'important');
          
          if (index === visibleIndex) {
            item.classList.remove('bk-media-announcement-hidden');
            item.classList.add('bk-media-announcement-entering');
            
            requestAnimationFrame(function() {
              item.classList.remove('bk-media-announcement-entering');
              item.classList.add('bk-media-announcement-visible');
              if (!skipObserver) {
                isUpdatingVisibility = false;
              }
            });
          } else {
            item.classList.remove('bk-media-announcement-visible', 'bk-media-announcement-entering');
            item.classList.add('bk-media-announcement-hidden');
          }
        });
      }
      
      function performCycle() {
        const targetIndex = cycleOrder[cycleIndex];
        
        isUpdatingVisibility = true;
        updateItemVisibility(targetIndex, true);
        
        cycleIndex = (cycleIndex + 1) % cycleOrder.length;
        
        setTimeout(function() {
          isUpdatingVisibility = false;
        }, 1300);
      }
      
      function startCycle() {
        stopCycle();
        
        if (!rotationEnabled) {
          hideNonMiddleItems();
          setTimeout(function() {
            setToMiddle(false);
          }, 50);
          return;
        }
        
        setToMiddle(true);
        cycleIndex = 1;
        
        const cycleIntervalMs = getRotationSpeed();
        
        cycleTimeout = setTimeout(function() {
          performCycle();
          
          cycleInterval = setInterval(function() {
            performCycle();
          }, cycleIntervalMs);
        }, cycleIntervalMs);
      }
      
      function stopCycle() {
        if (cycleInterval) {
          clearInterval(cycleInterval);
          cycleInterval = null;
        }
        if (cycleTimeout) {
          clearTimeout(cycleTimeout);
          cycleTimeout = null;
        }
      }
      
      function checkMobile() {
        if (window.matchMedia('(max-width: 699px)').matches) {
          startCycle();
        } else {
          stopCycle();
          showAllItems();
          if (bar.select && typeof bar.select === 'function' && bar.selectedIndex !== 0) {
            bar.select(0, { animate: false });
          }
        }
      }
      
      function setContainerHeight() {
        let maxHeight = 0;
        items.forEach(function(item) {
          const originalOpacity = item.style.opacity;
          const originalVisibility = item.style.visibility;
          item.style.opacity = '1';
          item.style.visibility = 'visible';
          const height = item.offsetHeight;
          item.style.opacity = originalOpacity;
          item.style.visibility = originalVisibility;
          if (height > maxHeight) {
            maxHeight = height;
          }
        });
        if (maxHeight > 0) {
          bar.style.minHeight = maxHeight + 'px';
        }
      }
      
      function initialize() {
        if (window.matchMedia('(max-width: 699px)').matches) {
          setToMiddle(true);
        }
        
        function waitForComponent(callback, maxAttempts) {
          maxAttempts = maxAttempts || 10;
          let attempts = 0;
          
          function check() {
            attempts++;
            if (bar.select && typeof bar.select === 'function' && items.length === 3) {
              callback();
            } else if (attempts < maxAttempts) {
              setTimeout(check, 50);
            } else {
              callback();
            }
          }
          
          check();
        }
        
        waitForComponent(function() {
          setTimeout(function() {
            setContainerHeight();
            
            if (window.matchMedia('(max-width: 699px)').matches) {
              setToMiddle(true);
              setTimeout(function() {
                checkMobile();
              }, 50);
            } else {
              showAllItems();
            }
          }, 100);
        });
      }
      
      initialize();
      
      window.addEventListener('resize', function() {
        if (window.matchMedia('(max-width: 699px)').matches) {
          setTimeout(setContainerHeight, 100);
        }
      });
      
      const mediaQuery = window.matchMedia('(max-width: 699px)');
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', checkMobile);
      } else {
        mediaQuery.addListener(checkMobile);
      }
      
      bar.addEventListener('mouseenter', stopCycle);
      bar.addEventListener('mouseleave', function() {
        if (window.matchMedia('(max-width: 699px)').matches) {
          startCycle();
        }
      });
      
      bar.addEventListener('touchstart', stopCycle);
      bar.addEventListener('touchend', function() {
        cycleTimeout = setTimeout(function() {
          if (window.matchMedia('(max-width: 699px)').matches) {
            startCycle();
          }
        }, 3000);
      });
      
      if (rotationEnabled) {
        const observer = new MutationObserver(function(mutations) {
          if (isUpdatingVisibility || cycleInterval !== null) return;
          
          mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'selected-index') {
              const selectedIndex = parseInt(bar.getAttribute('selected-index') || bar.selectedIndex || middleIndex);
              if (window.matchMedia('(max-width: 699px)').matches) {
                if (selectedIndex !== middleIndex) {
                  updateItemVisibility(selectedIndex);
                }
              }
            }
          });
        });
        
        observer.observe(bar, {
          attributes: true,
          attributeFilter: ['selected-index']
        });
      }
    });
  }

  function setupHeaderSidebarDrawerAnnouncement() {
    if (document.documentElement.hasAttribute('data-bk-drawer-announcement-toggle')) return;
    document.documentElement.setAttribute('data-bk-drawer-announcement-toggle', '');
    document.addEventListener(
      'toggle',
      function (e) {
        var drawer = e.target;
        if (!drawer || drawer.id !== 'header-sidebar-menu') return;
        if (!drawer.open) return;
        initMobileNavAnnouncementClone();
        setTimeout(function () {
          syncAnnouncementMirrorFromSource();
        }, 50);
      },
      true
    );
    document.addEventListener(
      'dialog:after-hide',
      function (e) {
        var drawer = e.target;
        if (!drawer || drawer.id !== 'header-sidebar-menu') return;
        var target = drawer.querySelector('[data-bk-mobile-nav-announcement]');
        if (target) target.innerHTML = '';
      },
      true
    );
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      setupHeaderSidebarDrawerAnnouncement();
      attachAnnouncementMirrorObserver();
      initAnnouncementBarAutoCycle();
    }, 500);
  });
  
  document.addEventListener('shopify:section:load', function() {
    setTimeout(function() {
      attachAnnouncementMirrorObserver();
      var drawer = document.getElementById('header-sidebar-menu');
      if (drawer && drawer.open) {
        initMobileNavAnnouncementClone();
        syncAnnouncementMirrorFromSource();
      }
      initAnnouncementBarAutoCycle();
    }, 500);
  });
  